/**
 * 教育部《国家学生体质健康标准（2014年修订）》完整项目与官方标准数据集
 */

export const STANDARDS_METADATA = {
    title: "国家学生体质健康标准",
    version: "2014年修订版",
    authority: "教育部 国家体育总局",
    effectiveDate: "2014年秋季学期起施行",
    status: "现行国家法定标准",
};

export const GRADE_STAGES = [
    { 
        key: "primary", 
        label: "小学", 
        grades: ["小学一年级", "小学二年级", "小学三年级", "小学四年级", "小学五年级", "小学六年级"] 
    },
    { 
        key: "junior", 
        label: "初中", 
        grades: ["初中一年级", "初中二年级", "初中三年级"] 
    },
    { 
        key: "senior", 
        label: "高中", 
        grades: ["高中一年级", "高中二年级", "高中三年级"] 
    },
    { 
        key: "college", 
        label: "大学", 
        grades: ["大学一二年级", "大学三四年级"] 
    },
];

export const ITEM_CONFIG = {
    bmi: { 
        label: "体重指数(BMI)", 
        unit: "kg/m²", 
        icon: "speedometer", 
        desc: "评价身体形态和营养发育状况", 
        color: "#04523C" 
    },
    vital_capacity: { 
        label: "肺活量", 
        unit: "ml", 
        icon: "fitness", 
        desc: "评价呼吸系统与心肺通气功能", 
        color: "#059669" 
    },
    run_50m: { 
        label: "50米跑", 
        unit: "秒", 
        icon: "stopwatch", 
        desc: "评价速度、灵敏度与爆发力素质", 
        color: "#EA580C" 
    },
    sit_and_reach: { 
        label: "坐位体前屈", 
        unit: "厘米", 
        icon: "body", 
        desc: "评价躯干、腰髋及下肢柔韧素质", 
        color: "#7C3AED" 
    },
    skip_rope: { 
        label: "一分钟跳绳", 
        unit: "次", 
        icon: "repeat", 
        desc: "评价下肢力量、速度与动作协调性", 
        color: "#D97706" 
    },
    sit_up: { 
        label: "一分钟仰卧起坐", 
        unit: "次", 
        icon: "fitness", 
        desc: "评价腹肌力量与核心肌肉耐力", 
        color: "#0891b2" 
    },
    pull_up: { 
        label: "引体向上", 
        unit: "次", 
        icon: "barbell", 
        desc: "评价上肢伸肌与背部肌肉力量", 
        color: "#e11d48" 
    },
    standing_long_jump: { 
        label: "立定跳远", 
        unit: "厘米", 
        icon: "trending-up", 
        desc: "评价下肢爆发力与协调用力能力", 
        color: "#056B4F" 
    },
    run_800m: { 
        label: "800米跑", 
        unit: "分.秒", 
        icon: "timer", 
        desc: "评价女生心肺功能与耐力素质", 
        color: "#DB2777" 
    },
    run_1000m: { 
        label: "1000米跑", 
        unit: "分.秒", 
        icon: "timer", 
        desc: "评价男生心肺功能与耐力素质", 
        color: "#7C3AED" 
    },
    run_50m8x: { 
        label: "50米×8往返跑", 
        unit: "分.秒", 
        icon: "walk", 
        desc: "评价心肺耐力与折返敏捷素质", 
        color: "#059669" 
    },
};

export const ITEM_WEIGHTS = {
    '小学一年级': { bmi: 15, vital_capacity: 15, run_50m: 20, sit_and_reach: 30, skip_rope: 20 },
    '小学二年级': { bmi: 15, vital_capacity: 15, run_50m: 20, sit_and_reach: 30, skip_rope: 20 },
    '小学三年级': { bmi: 15, vital_capacity: 15, run_50m: 20, sit_and_reach: 20, skip_rope: 20, sit_up: 10 },
    '小学四年级': { bmi: 15, vital_capacity: 15, run_50m: 20, sit_and_reach: 20, skip_rope: 20, sit_up: 10 },
    '小学五年级': { bmi: 15, vital_capacity: 15, run_50m: 20, sit_and_reach: 10, skip_rope: 10, sit_up: 10, run_50m8x: 20 },
    '小学六年级': { bmi: 15, vital_capacity: 15, run_50m: 20, sit_and_reach: 10, skip_rope: 10, sit_up: 10, run_50m8x: 20 },
    'default_male': { bmi: 15, vital_capacity: 15, run_50m: 20, sit_and_reach: 10, standing_long_jump: 10, pull_up: 10, run_1000m: 20 },
    'default_female': { bmi: 15, vital_capacity: 15, run_50m: 20, sit_and_reach: 10, standing_long_jump: 10, sit_up: 10, run_800m: 20 },
};

export const STANDARDS_DATA = {
  "小学一年级_男_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "小学一年级",
    "gender": "男",
    "display_order": 1,
    "scoring_table": {
      "60": "≥20.4",
      "80": "≤13.4;18.2~20.3",
      "100": "13.5~18.1"
    }
  },
  "小学二年级_男_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "小学二年级",
    "gender": "男",
    "display_order": 1,
    "scoring_table": {
      "60": "≥20.5",
      "80": "≤13.6;18.5~20.4",
      "100": "13.7~18.4"
    }
  },
  "小学三年级_男_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "小学三年级",
    "gender": "男",
    "display_order": 1,
    "scoring_table": {
      "60": "≥22.2",
      "80": "≤13.8;19.5~22.1",
      "100": "13.9~19.4"
    }
  },
  "小学四年级_男_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "小学四年级",
    "gender": "男",
    "display_order": 1,
    "scoring_table": {
      "60": "≥22.7",
      "80": "≤14.1;20.2~22.6",
      "100": "14.2~20.1"
    }
  },
  "小学五年级_男_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "小学五年级",
    "gender": "男",
    "display_order": 1,
    "scoring_table": {
      "60": "≥24.2",
      "80": "≤14.3;21.5~24.1",
      "100": "14.4~21.4"
    }
  },
  "小学六年级_男_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "小学六年级",
    "gender": "男",
    "display_order": 1,
    "scoring_table": {
      "60": "≥24.6",
      "80": "≤14.6;21.9~24.5",
      "100": "14.7~21.8"
    }
  },
  "初中一年级_男_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "初中一年级",
    "gender": "男",
    "display_order": 1,
    "scoring_table": {
      "60": "≥25.0",
      "80": "≤15.4;22.2~24.9",
      "100": "15.5~22.1"
    }
  },
  "初中二年级_男_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "初中二年级",
    "gender": "男",
    "display_order": 1,
    "scoring_table": {
      "60": "≥25.3",
      "80": "≤15.6;22.6~25.2",
      "100": "15.7~22.5"
    }
  },
  "初中三年级_男_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "初中三年级",
    "gender": "男",
    "display_order": 1,
    "scoring_table": {
      "60": "≥26.1",
      "80": "≤15.7;22.9~26.0",
      "100": "15.8~22.8"
    }
  },
  "高中一年级_男_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "高中一年级",
    "gender": "男",
    "display_order": 1,
    "scoring_table": {
      "60": "≥26.4",
      "80": "≤16.4;23.3~26.3",
      "100": "16.5~23.2"
    }
  },
  "高中二年级_男_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "高中二年级",
    "gender": "男",
    "display_order": 1,
    "scoring_table": {
      "60": "≥26.6",
      "80": "≤16.7;23.8~26.5",
      "100": "16.8~23.7"
    }
  },
  "高中三年级_男_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "高中三年级",
    "gender": "男",
    "display_order": 1,
    "scoring_table": {
      "60": "≥27.4",
      "80": "≤17.2;23.9~27.3",
      "100": "17.3~23.8"
    }
  },
  "小学一年级_男_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "小学一年级",
    "gender": "男",
    "display_order": 2,
    "scoring_table": {
      "10": "500.0",
      "20": "540.0",
      "30": "580.0",
      "40": "620.0",
      "50": "660.0",
      "60": "700.0",
      "62": "760.0",
      "64": "820.0",
      "66": "880.0",
      "68": "940.0",
      "70": "1000.0",
      "72": "1060.0",
      "74": "1120.0",
      "76": "1180.0",
      "78": "1240.0",
      "80": "1300.0",
      "85": "1400.0",
      "90": "1500.0",
      "95": "1600.0",
      "100": "1700.0"
    }
  },
  "小学二年级_男_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "小学二年级",
    "gender": "男",
    "display_order": 2,
    "scoring_table": {
      "10": "550.0",
      "20": "600.0",
      "30": "650.0",
      "40": "700.0",
      "50": "750.0",
      "60": "800.0",
      "62": "870.0",
      "64": "940.0",
      "66": "1010.0",
      "68": "1080.0",
      "70": "1150.0",
      "72": "1220.0",
      "74": "1290.0",
      "76": "1360.0",
      "78": "1430.0",
      "80": "1500.0",
      "85": "1650.0",
      "90": "1800.0",
      "95": "1900.0",
      "100": "2000.0"
    }
  },
  "小学三年级_男_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "小学三年级",
    "gender": "男",
    "display_order": 2,
    "scoring_table": {
      "10": "600.0",
      "20": "660.0",
      "30": "720.0",
      "40": "780.0",
      "50": "840.0",
      "60": "900.0",
      "62": "980.0",
      "64": "1060.0",
      "66": "1140.0",
      "68": "1220.0",
      "70": "1300.0",
      "72": "1380.0",
      "74": "1460.0",
      "76": "1540.0",
      "78": "1620.0",
      "80": "1700.0",
      "85": "1900.0",
      "90": "2100.0",
      "95": "2200.0",
      "100": "2300.0"
    }
  },
  "小学四年级_男_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "小学四年级",
    "gender": "男",
    "display_order": 2,
    "scoring_table": {
      "10": "750.0",
      "20": "820.0",
      "30": "890.0",
      "40": "960.0",
      "50": "1030.0",
      "60": "1100.0",
      "62": "1180.0",
      "64": "1260.0",
      "66": "1340.0",
      "68": "1420.0",
      "70": "1500.0",
      "72": "1580.0",
      "74": "1660.0",
      "76": "1740.0",
      "78": "1820.0",
      "80": "1900.0",
      "85": "2150.0",
      "90": "2400.0",
      "95": "2500.0",
      "100": "2600.0"
    }
  },
  "小学五年级_男_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "小学五年级",
    "gender": "男",
    "display_order": 2,
    "scoring_table": {
      "10": "900.0",
      "20": "980.0",
      "30": "1060.0",
      "40": "1140.0",
      "50": "1220.0",
      "60": "1300.0",
      "62": "1390.0",
      "64": "1480.0",
      "66": "1570.0",
      "68": "1660.0",
      "70": "1750.0",
      "72": "1840.0",
      "74": "1930.0",
      "76": "2020.0",
      "78": "2110.0",
      "80": "2200.0",
      "85": "2450.0",
      "90": "2700.0",
      "95": "2800.0",
      "100": "2900.0"
    }
  },
  "小学六年级_男_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "小学六年级",
    "gender": "男",
    "display_order": 2,
    "scoring_table": {
      "10": "1050.0",
      "20": "1140.0",
      "30": "1230.0",
      "40": "1320.0",
      "50": "1410.0",
      "60": "1500.0",
      "62": "1600.0",
      "64": "1700.0",
      "66": "1800.0",
      "68": "1900.0",
      "70": "2000.0",
      "72": "2100.0",
      "74": "2200.0",
      "76": "2300.0",
      "78": "2400.0",
      "80": "2500.0",
      "85": "2750.0",
      "90": "3000.0",
      "95": "3100.0",
      "100": "3200.0"
    }
  },
  "初中一年级_男_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "初中一年级",
    "gender": "男",
    "display_order": 2,
    "scoring_table": {
      "10": "1200.0",
      "20": "1300.0",
      "30": "1400.0",
      "40": "1500.0",
      "50": "1600.0",
      "60": "1700.0",
      "62": "1820.0",
      "64": "1940.0",
      "66": "2060.0",
      "68": "2180.0",
      "70": "2300.0",
      "72": "2420.0",
      "74": "2540.0",
      "76": "2660.0",
      "78": "2780.0",
      "80": "2900.0",
      "85": "3150.0",
      "90": "3400.0",
      "95": "3520.0",
      "100": "3640.0"
    }
  },
  "初中二年级_男_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "初中二年级",
    "gender": "男",
    "display_order": 2,
    "scoring_table": {
      "10": "1450.0",
      "20": "1560.0",
      "30": "1670.0",
      "40": "1780.0",
      "50": "1890.0",
      "60": "2000.0",
      "62": "2120.0",
      "64": "2240.0",
      "66": "2360.0",
      "68": "2480.0",
      "70": "2600.0",
      "72": "2720.0",
      "74": "2840.0",
      "76": "2960.0",
      "78": "3080.0",
      "80": "3200.0",
      "85": "3450.0",
      "90": "3700.0",
      "95": "3820.0",
      "100": "3940.0"
    }
  },
  "初中三年级_男_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "初中三年级",
    "gender": "男",
    "display_order": 2,
    "scoring_table": {
      "10": "1700.0",
      "20": "1820.0",
      "30": "1940.0",
      "40": "2060.0",
      "50": "2180.0",
      "60": "2300.0",
      "62": "2420.0",
      "64": "2540.0",
      "66": "2660.0",
      "68": "2780.0",
      "70": "2900.0",
      "72": "3020.0",
      "74": "3140.0",
      "76": "3260.0",
      "78": "3380.0",
      "80": "3500.0",
      "85": "3750.0",
      "90": "4000.0",
      "95": "4120.0",
      "100": "4240.0"
    }
  },
  "高中一年级_男_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "高中一年级",
    "gender": "男",
    "display_order": 2,
    "scoring_table": {
      "10": "1950.0",
      "20": "2080.0",
      "30": "2210.0",
      "40": "2340.0",
      "50": "2470.0",
      "60": "2600.0",
      "62": "2720.0",
      "64": "2840.0",
      "66": "2960.0",
      "68": "3080.0",
      "70": "3200.0",
      "72": "3320.0",
      "74": "3440.0",
      "76": "3560.0",
      "78": "3680.0",
      "80": "3800.0",
      "85": "4050.0",
      "90": "4300.0",
      "95": "4420.0",
      "100": "4540.0"
    }
  },
  "高中二年级_男_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "高中二年级",
    "gender": "男",
    "display_order": 2,
    "scoring_table": {
      "10": "2100.0",
      "20": "2240.0",
      "30": "2380.0",
      "40": "2520.0",
      "50": "2660.0",
      "60": "2800.0",
      "62": "2920.0",
      "64": "3040.0",
      "66": "3160.0",
      "68": "3280.0",
      "70": "3400.0",
      "72": "3520.0",
      "74": "3640.0",
      "76": "3760.0",
      "78": "3880.0",
      "80": "4000.0",
      "85": "4250.0",
      "90": "4500.0",
      "95": "4620.0",
      "100": "4740.0"
    }
  },
  "高中三年级_男_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "高中三年级",
    "gender": "男",
    "display_order": 2,
    "scoring_table": {
      "10": "2250.0",
      "20": "2400.0",
      "30": "2550.0",
      "40": "2700.0",
      "50": "2850.0",
      "60": "3000.0",
      "62": "3120.0",
      "64": "3240.0",
      "66": "3360.0",
      "68": "3480.0",
      "70": "3600.0",
      "72": "3720.0",
      "74": "3840.0",
      "76": "3960.0",
      "78": "4080.0",
      "80": "4200.0",
      "85": "4450.0",
      "90": "4700.0",
      "95": "4820.0",
      "100": "4940.0"
    }
  },
  "大学一二年级_男_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "大学一二年级",
    "gender": "男",
    "display_order": 2,
    "scoring_table": {
      "10": "2300",
      "20": "2460",
      "30": "2620",
      "40": "2780",
      "50": "2940",
      "60": "3100",
      "62": "3220",
      "64": "3340",
      "66": "3460",
      "68": "3580",
      "70": "3700",
      "72": "3820",
      "74": "3940",
      "76": "4060",
      "78": "4180",
      "80": "4300",
      "85": "4550",
      "90": "4800",
      "95": "4920",
      "100": "5040"
    }
  },
  "大学三四年级_男_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "大学三四年级",
    "gender": "男",
    "display_order": 2,
    "scoring_table": {
      "10": "2350",
      "20": "2520",
      "30": "2690",
      "40": "2860",
      "50": "3030",
      "60": "3200",
      "62": "3320",
      "64": "3440",
      "66": "3560",
      "68": "3680",
      "70": "3800",
      "72": "3920",
      "74": "4040",
      "76": "4160",
      "78": "4280",
      "80": "4400",
      "85": "4650",
      "90": "4900",
      "95": "5020",
      "100": "5140"
    }
  },
  "小学一年级_女_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "小学一年级",
    "gender": "女",
    "display_order": 2,
    "scoring_table": {
      "10": "500.0",
      "20": "520.0",
      "30": "540.0",
      "40": "560.0",
      "50": "580.0",
      "60": "600.0",
      "62": "640.0",
      "64": "680.0",
      "66": "720.0",
      "68": "760.0",
      "70": "800.0",
      "72": "840.0",
      "74": "880.0",
      "76": "920.0",
      "78": "960.0",
      "80": "1000.0",
      "85": "1100.0",
      "90": "1200.0",
      "95": "1300.0",
      "100": "1400.0"
    }
  },
  "小学二年级_女_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "小学二年级",
    "gender": "女",
    "display_order": 2,
    "scoring_table": {
      "10": "600.0",
      "20": "620.0",
      "30": "640.0",
      "40": "660.0",
      "50": "680.0",
      "60": "700.0",
      "62": "750.0",
      "64": "800.0",
      "66": "850.0",
      "68": "900.0",
      "70": "950.0",
      "72": "1000.0",
      "74": "1050.0",
      "76": "1100.0",
      "78": "1150.0",
      "80": "1200.0",
      "85": "1300.0",
      "90": "1400.0",
      "95": "1500.0",
      "100": "1600.0"
    }
  },
  "小学三年级_女_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "小学三年级",
    "gender": "女",
    "display_order": 2,
    "scoring_table": {
      "10": "700.0",
      "20": "720.0",
      "30": "740.0",
      "40": "760.0",
      "50": "780.0",
      "60": "800.0",
      "62": "860.0",
      "64": "920.0",
      "66": "980.0",
      "68": "1040.0",
      "70": "1100.0",
      "72": "1160.0",
      "74": "1220.0",
      "76": "1280.0",
      "78": "1340.0",
      "80": "1400.0",
      "85": "1500.0",
      "90": "1600.0",
      "95": "1700.0",
      "100": "1800.0"
    }
  },
  "小学四年级_女_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "小学四年级",
    "gender": "女",
    "display_order": 2,
    "scoring_table": {
      "10": "800.0",
      "20": "820.0",
      "30": "840.0",
      "40": "860.0",
      "50": "880.0",
      "60": "900.0",
      "62": "970.0",
      "64": "1040.0",
      "66": "1110.0",
      "68": "1180.0",
      "70": "1250.0",
      "72": "1320.0",
      "74": "1390.0",
      "76": "1460.0",
      "78": "1530.0",
      "80": "1600.0",
      "85": "1700.0",
      "90": "1800.0",
      "95": "1900.0",
      "100": "2000.0"
    }
  },
  "小学五年级_女_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "小学五年级",
    "gender": "女",
    "display_order": 2,
    "scoring_table": {
      "10": "900.0",
      "20": "930.0",
      "30": "960.0",
      "40": "990.0",
      "50": "1020.0",
      "60": "1050.0",
      "62": "1130.0",
      "64": "1210.0",
      "66": "1290.0",
      "68": "1370.0",
      "70": "1450.0",
      "72": "1530.0",
      "74": "1610.0",
      "76": "1690.0",
      "78": "1770.0",
      "80": "1850.0",
      "85": "1950.0",
      "90": "2050.0",
      "95": "2150.0",
      "100": "2250.0"
    }
  },
  "小学六年级_女_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "小学六年级",
    "gender": "女",
    "display_order": 2,
    "scoring_table": {
      "10": "1050.0",
      "20": "1080.0",
      "30": "1110.0",
      "40": "1140.0",
      "50": "1170.0",
      "60": "1200.0",
      "62": "1290.0",
      "64": "1380.0",
      "66": "1470.0",
      "68": "1560.0",
      "70": "1650.0",
      "72": "1740.0",
      "74": "1830.0",
      "76": "1920.0",
      "78": "2010.0",
      "80": "2100.0",
      "85": "2200.0",
      "90": "2300.0",
      "95": "2400.0",
      "100": "2500.0"
    }
  },
  "初中一年级_女_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "初中一年级",
    "gender": "女",
    "display_order": 2,
    "scoring_table": {
      "10": "1150.0",
      "20": "1190.0",
      "30": "1230.0",
      "40": "1270.0",
      "50": "1310.0",
      "60": "1350.0",
      "62": "1450.0",
      "64": "1550.0",
      "66": "1650.0",
      "68": "1750.0",
      "70": "1850.0",
      "72": "1950.0",
      "74": "2050.0",
      "76": "2150.0",
      "78": "2250.0",
      "80": "2350.0",
      "85": "2450.0",
      "90": "2550.0",
      "95": "2650.0",
      "100": "2750.0"
    }
  },
  "初中二年级_女_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "初中二年级",
    "gender": "女",
    "display_order": 2,
    "scoring_table": {
      "10": "1300.0",
      "20": "1340.0",
      "30": "1380.0",
      "40": "1420.0",
      "50": "1460.0",
      "60": "1500.0",
      "62": "1600.0",
      "64": "1700.0",
      "66": "1800.0",
      "68": "1900.0",
      "70": "2000.0",
      "72": "2100.0",
      "74": "2200.0",
      "76": "2300.0",
      "78": "2400.0",
      "80": "2500.0",
      "85": "2650.0",
      "90": "2800.0",
      "95": "2850.0",
      "100": "2900.0"
    }
  },
  "初中三年级_女_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "初中三年级",
    "gender": "女",
    "display_order": 2,
    "scoring_table": {
      "10": "1450.0",
      "20": "1490.0",
      "30": "1530.0",
      "40": "1570.0",
      "50": "1610.0",
      "60": "1650.0",
      "62": "1750.0",
      "64": "1850.0",
      "66": "1950.0",
      "68": "2050.0",
      "70": "2150.0",
      "72": "2250.0",
      "74": "2350.0",
      "76": "2450.0",
      "78": "2550.0",
      "80": "2650.0",
      "85": "2800.0",
      "90": "2950.0",
      "95": "3000.0",
      "100": "3050.0"
    }
  },
  "高中一年级_女_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "高中一年级",
    "gender": "女",
    "display_order": 2,
    "scoring_table": {
      "10": "1550.0",
      "20": "1590.0",
      "30": "1630.0",
      "40": "1670.0",
      "50": "1710.0",
      "60": "1750.0",
      "62": "1850.0",
      "64": "1950.0",
      "66": "2050.0",
      "68": "2150.0",
      "70": "2250.0",
      "72": "2350.0",
      "74": "2450.0",
      "76": "2550.0",
      "78": "2650.0",
      "80": "2750.0",
      "85": "2900.0",
      "90": "3050.0",
      "95": "3100.0",
      "100": "3150.0"
    }
  },
  "高中二年级_女_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "高中二年级",
    "gender": "女",
    "display_order": 2,
    "scoring_table": {
      "10": "1650.0",
      "20": "1690.0",
      "30": "1730.0",
      "40": "1770.0",
      "50": "1810.0",
      "60": "1850.0",
      "62": "1950.0",
      "64": "2050.0",
      "66": "2150.0",
      "68": "2250.0",
      "70": "2350.0",
      "72": "2450.0",
      "74": "2550.0",
      "76": "2650.0",
      "78": "2750.0",
      "80": "2850.0",
      "85": "3000.0",
      "90": "3150.0",
      "95": "3200.0",
      "100": "3250.0"
    }
  },
  "高中三年级_女_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "高中三年级",
    "gender": "女",
    "display_order": 2,
    "scoring_table": {
      "10": "1750.0",
      "20": "1790.0",
      "30": "1830.0",
      "40": "1870.0",
      "50": "1910.0",
      "60": "1950.0",
      "62": "2050.0",
      "64": "2150.0",
      "66": "2250.0",
      "68": "2350.0",
      "70": "2450.0",
      "72": "2550.0",
      "74": "2650.0",
      "76": "2750.0",
      "78": "2850.0",
      "80": "2950.0",
      "85": "3100.0",
      "90": "3250.0",
      "95": "3300.0",
      "100": "3350.0"
    }
  },
  "大学一二年级_女_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "大学一二年级",
    "gender": "女",
    "display_order": 2,
    "scoring_table": {
      "10": "1800",
      "20": "1840",
      "30": "1880",
      "40": "1920",
      "50": "1960",
      "60": "2000",
      "62": "2100",
      "64": "2200",
      "66": "2300",
      "68": "2400",
      "70": "2500",
      "72": "2600",
      "74": "2700",
      "76": "2800",
      "78": "2900",
      "80": "3000",
      "85": "3150",
      "90": "3300",
      "95": "3350",
      "100": "3400"
    }
  },
  "大学三四年级_女_vital_capacity": {
    "item_code": "vital_capacity",
    "item_name": "肺活量",
    "grade": "大学三四年级",
    "gender": "女",
    "display_order": 2,
    "scoring_table": {
      "10": "1850",
      "20": "1890",
      "30": "1930",
      "40": "1970",
      "50": "2010",
      "60": "2050",
      "62": "2150",
      "64": "2250",
      "66": "2350",
      "68": "2450",
      "70": "2550",
      "72": "2650",
      "74": "2750",
      "76": "2850",
      "78": "2950",
      "80": "3050",
      "85": "3200",
      "90": "3350",
      "95": "3400",
      "100": "3450"
    }
  },
  "小学一年级_男_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "小学一年级",
    "gender": "男",
    "display_order": 3,
    "scoring_table": {
      "10": "13.6",
      "20": "13.4",
      "30": "13.2",
      "40": "13.0",
      "50": "12.8",
      "60": "12.6",
      "62": "12.4",
      "64": "12.2",
      "66": "12.0",
      "68": "11.8",
      "70": "11.6",
      "72": "11.4",
      "74": "11.2",
      "76": "11.0",
      "78": "10.8",
      "80": "10.6",
      "85": "10.5",
      "90": "10.4",
      "95": "10.3",
      "100": "10.2"
    }
  },
  "小学二年级_男_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "小学二年级",
    "gender": "男",
    "display_order": 3,
    "scoring_table": {
      "10": "13.0",
      "20": "12.8",
      "30": "12.6",
      "40": "12.4",
      "50": "12.2",
      "60": "12.0",
      "62": "11.8",
      "64": "11.6",
      "66": "11.4",
      "68": "11.2",
      "70": "11.0",
      "72": "10.8",
      "74": "10.6",
      "76": "10.4",
      "78": "10.2",
      "80": "10.0",
      "85": "9.9",
      "90": "9.8",
      "95": "9.7",
      "100": "9.6"
    }
  },
  "小学三年级_男_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "小学三年级",
    "gender": "男",
    "display_order": 3,
    "scoring_table": {
      "10": "12.5",
      "20": "12.3",
      "30": "12.1",
      "40": "11.9",
      "50": "11.7",
      "60": "11.5",
      "62": "11.3",
      "64": "11.1",
      "66": "10.9",
      "68": "10.7",
      "70": "10.5",
      "72": "10.3",
      "74": "10.1",
      "76": "9.9",
      "78": "9.7",
      "80": "9.5",
      "85": "9.4",
      "90": "9.3",
      "95": "9.2",
      "100": "9.1"
    }
  },
  "小学四年级_男_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "小学四年级",
    "gender": "男",
    "display_order": 3,
    "scoring_table": {
      "10": "12.1",
      "20": "11.9",
      "30": "11.7",
      "40": "11.5",
      "50": "11.3",
      "60": "11.1",
      "62": "10.9",
      "64": "10.7",
      "66": "10.5",
      "68": "10.3",
      "70": "10.1",
      "72": "9.9",
      "74": "9.7",
      "76": "9.5",
      "78": "9.3",
      "80": "9.1",
      "85": "9.0",
      "90": "8.9",
      "95": "8.8",
      "100": "8.7"
    }
  },
  "小学五年级_男_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "小学五年级",
    "gender": "男",
    "display_order": 3,
    "scoring_table": {
      "10": "11.8",
      "20": "11.6",
      "30": "11.4",
      "40": "11.2",
      "50": "11.0",
      "60": "10.8",
      "62": "10.6",
      "64": "10.4",
      "66": "10.2",
      "68": "10.0",
      "70": "9.8",
      "72": "9.6",
      "74": "9.4",
      "76": "9.2",
      "78": "9.0",
      "80": "8.8",
      "85": "8.7",
      "90": "8.6",
      "95": "8.5",
      "100": "8.4"
    }
  },
  "小学六年级_男_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "小学六年级",
    "gender": "男",
    "display_order": 3,
    "scoring_table": {
      "10": "11.6",
      "20": "11.4",
      "30": "11.2",
      "40": "11.0",
      "50": "10.8",
      "60": "10.6",
      "62": "10.4",
      "64": "10.2",
      "66": "10.0",
      "68": "9.8",
      "70": "9.6",
      "72": "9.4",
      "74": "9.2",
      "76": "9.0",
      "78": "8.8",
      "80": "8.6",
      "85": "8.5",
      "90": "8.4",
      "95": "8.3",
      "100": "8.2"
    }
  },
  "初中一年级_男_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "初中一年级",
    "gender": "男",
    "display_order": 3,
    "scoring_table": {
      "10": "11.2",
      "20": "11.0",
      "30": "10.8",
      "40": "10.6",
      "50": "10.4",
      "60": "10.2",
      "62": "10.0",
      "64": "9.8",
      "66": "9.6",
      "68": "9.4",
      "70": "9.2",
      "72": "9.0",
      "74": "8.8",
      "76": "8.6",
      "78": "8.4",
      "80": "8.2",
      "85": "8.1",
      "90": "8.0",
      "95": "7.9",
      "100": "7.8"
    }
  },
  "初中二年级_男_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "初中二年级",
    "gender": "男",
    "display_order": 3,
    "scoring_table": {
      "10": "10.9",
      "20": "10.7",
      "30": "10.5",
      "40": "10.3",
      "50": "10.1",
      "60": "9.9",
      "62": "9.7",
      "64": "9.5",
      "66": "9.3",
      "68": "9.1",
      "70": "8.9",
      "72": "8.7",
      "74": "8.5",
      "76": "8.3",
      "78": "8.1",
      "80": "7.9",
      "85": "7.8",
      "90": "7.7",
      "95": "7.6",
      "100": "7.5"
    }
  },
  "初中三年级_男_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "初中三年级",
    "gender": "男",
    "display_order": 3,
    "scoring_table": {
      "10": "10.7",
      "20": "10.5",
      "30": "10.3",
      "40": "10.1",
      "50": "9.9",
      "60": "9.7",
      "62": "9.5",
      "64": "9.3",
      "66": "9.1",
      "68": "8.9",
      "70": "8.7",
      "72": "8.5",
      "74": "8.3",
      "76": "8.1",
      "78": "7.9",
      "80": "7.7",
      "85": "7.6",
      "90": "7.5",
      "95": "7.4",
      "100": "7.3"
    }
  },
  "高中一年级_男_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "高中一年级",
    "gender": "男",
    "display_order": 3,
    "scoring_table": {
      "10": "10.5",
      "20": "10.3",
      "30": "10.1",
      "40": "9.9",
      "50": "9.7",
      "60": "9.5",
      "62": "9.3",
      "64": "9.1",
      "66": "8.9",
      "68": "8.7",
      "70": "8.5",
      "72": "8.3",
      "74": "8.1",
      "76": "7.9",
      "78": "7.7",
      "80": "7.5",
      "85": "7.4",
      "90": "7.3",
      "95": "7.2",
      "100": "7.1"
    }
  },
  "高中二年级_男_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "高中二年级",
    "gender": "男",
    "display_order": 3,
    "scoring_table": {
      "10": "10.4",
      "20": "10.2",
      "30": "10.0",
      "40": "9.8",
      "50": "9.6",
      "60": "9.4",
      "62": "9.2",
      "64": "9.0",
      "66": "8.8",
      "68": "8.6",
      "70": "8.4",
      "72": "8.2",
      "74": "8.0",
      "76": "7.8",
      "78": "7.6",
      "80": "7.4",
      "85": "7.3",
      "90": "7.2",
      "95": "7.1",
      "100": "7.0"
    }
  },
  "高中三年级_男_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "高中三年级",
    "gender": "男",
    "display_order": 3,
    "scoring_table": {
      "10": "10.2",
      "20": "10.0",
      "30": "9.8",
      "40": "9.6",
      "50": "9.4",
      "60": "9.2",
      "62": "9.0",
      "64": "8.8",
      "66": "8.6",
      "68": "8.4",
      "70": "8.2",
      "72": "8.0",
      "74": "7.8",
      "76": "7.6",
      "78": "7.4",
      "80": "7.2",
      "85": "7.1",
      "90": "7.0",
      "95": "6.9",
      "100": "6.8"
    }
  },
  "大学一二年级_男_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "大学一二年级",
    "gender": "男",
    "display_order": 3,
    "scoring_table": {
      "10": "10.1",
      "20": "9.9",
      "30": "9.7",
      "40": "9.5",
      "50": "9.3",
      "60": "9.1",
      "62": "8.9",
      "64": "8.7",
      "66": "8.5",
      "68": "8.3",
      "70": "8.1",
      "72": "7.9",
      "74": "7.7",
      "76": "7.5",
      "78": "7.3",
      "80": "7.1",
      "85": "7",
      "90": "6.9",
      "95": "6.8",
      "100": "6.7"
    }
  },
  "大学三四年级_男_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "大学三四年级",
    "gender": "男",
    "display_order": 3,
    "scoring_table": {
      "10": "10",
      "20": "9.8",
      "30": "9.6",
      "40": "9.4",
      "50": "9.2",
      "60": "9",
      "62": "8.8",
      "64": "8.6",
      "66": "8.4",
      "68": "8.2",
      "70": "8",
      "72": "7.8",
      "74": "7.6",
      "76": "7.4",
      "78": "7.2",
      "80": "7",
      "85": "6.9",
      "90": "6.8",
      "95": "6.7",
      "100": "6.6"
    }
  },
  "小学一年级_女_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "小学一年级",
    "gender": "女",
    "display_order": 3,
    "scoring_table": {
      "10": "14.8",
      "20": "14.6",
      "30": "14.4",
      "40": "14.2",
      "50": "14.0",
      "60": "13.8",
      "62": "13.6",
      "64": "13.4",
      "66": "13.2",
      "68": "13.0",
      "70": "12.8",
      "72": "12.6",
      "74": "12.4",
      "76": "12.2",
      "78": "12.0",
      "80": "11.8",
      "85": "11.5",
      "90": "11.2",
      "95": "11.1",
      "100": "11.0"
    }
  },
  "小学二年级_女_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "小学二年级",
    "gender": "女",
    "display_order": 3,
    "scoring_table": {
      "10": "13.8",
      "20": "13.6",
      "30": "13.4",
      "40": "13.2",
      "50": "13.0",
      "60": "12.8",
      "62": "12.6",
      "64": "12.4",
      "66": "12.2",
      "68": "12.0",
      "70": "11.8",
      "72": "11.6",
      "74": "11.4",
      "76": "11.2",
      "78": "11.0",
      "80": "10.8",
      "85": "10.5",
      "90": "10.2",
      "95": "10.1",
      "100": "10.0"
    }
  },
  "小学三年级_女_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "小学三年级",
    "gender": "女",
    "display_order": 3,
    "scoring_table": {
      "10": "13.0",
      "20": "12.8",
      "30": "12.6",
      "40": "12.4",
      "50": "12.2",
      "60": "12.0",
      "62": "11.8",
      "64": "11.6",
      "66": "11.4",
      "68": "11.2",
      "70": "11.0",
      "72": "10.8",
      "74": "10.6",
      "76": "10.4",
      "78": "10.2",
      "80": "10.0",
      "85": "9.7",
      "90": "9.4",
      "95": "9.3",
      "100": "9.2"
    }
  },
  "小学四年级_女_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "小学四年级",
    "gender": "女",
    "display_order": 3,
    "scoring_table": {
      "10": "12.5",
      "20": "12.3",
      "30": "12.1",
      "40": "11.9",
      "50": "11.7",
      "60": "11.5",
      "62": "11.3",
      "64": "11.1",
      "66": "10.9",
      "68": "10.7",
      "70": "10.5",
      "72": "10.3",
      "74": "10.1",
      "76": "9.9",
      "78": "9.7",
      "80": "9.5",
      "85": "9.2",
      "90": "8.9",
      "95": "8.8",
      "100": "8.7"
    }
  },
  "小学五年级_女_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "小学五年级",
    "gender": "女",
    "display_order": 3,
    "scoring_table": {
      "10": "12.1",
      "20": "11.9",
      "30": "11.7",
      "40": "11.5",
      "50": "11.3",
      "60": "11.1",
      "62": "10.9",
      "64": "10.7",
      "66": "10.5",
      "68": "10.3",
      "70": "10.1",
      "72": "9.9",
      "74": "9.7",
      "76": "9.5",
      "78": "9.3",
      "80": "9.1",
      "85": "8.8",
      "90": "8.5",
      "95": "8.4",
      "100": "8.3"
    }
  },
  "小学六年级_女_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "小学六年级",
    "gender": "女",
    "display_order": 3,
    "scoring_table": {
      "10": "12.0",
      "20": "11.8",
      "30": "11.6",
      "40": "11.4",
      "50": "11.2",
      "60": "11.0",
      "62": "10.8",
      "64": "10.6",
      "66": "10.4",
      "68": "10.2",
      "70": "10.0",
      "72": "9.8",
      "74": "9.6",
      "76": "9.4",
      "78": "9.2",
      "80": "9.0",
      "85": "8.7",
      "90": "8.4",
      "95": "8.3",
      "100": "8.2"
    }
  },
  "初中一年级_女_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "初中一年级",
    "gender": "女",
    "display_order": 3,
    "scoring_table": {
      "10": "11.9",
      "20": "11.7",
      "30": "11.5",
      "40": "11.3",
      "50": "11.1",
      "60": "10.9",
      "62": "10.7",
      "64": "10.5",
      "66": "10.3",
      "68": "10.1",
      "70": "9.9",
      "72": "9.7",
      "74": "9.5",
      "76": "9.3",
      "78": "9.1",
      "80": "8.9",
      "85": "8.6",
      "90": "8.3",
      "95": "8.2",
      "100": "8.1"
    }
  },
  "初中二年级_女_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "初中二年级",
    "gender": "女",
    "display_order": 3,
    "scoring_table": {
      "10": "11.8",
      "20": "11.6",
      "30": "11.4",
      "40": "11.2",
      "50": "11.0",
      "60": "10.8",
      "62": "10.6",
      "64": "10.4",
      "66": "10.2",
      "68": "10.0",
      "70": "9.8",
      "72": "9.6",
      "74": "9.4",
      "76": "9.2",
      "78": "9.0",
      "80": "8.8",
      "85": "8.5",
      "90": "8.2",
      "95": "8.1",
      "100": "8.0"
    }
  },
  "初中三年级_女_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "初中三年级",
    "gender": "女",
    "display_order": 3,
    "scoring_table": {
      "10": "11.7",
      "20": "11.5",
      "30": "11.3",
      "40": "11.1",
      "50": "10.9",
      "60": "10.7",
      "62": "10.5",
      "64": "10.3",
      "66": "10.1",
      "68": "9.9",
      "70": "9.7",
      "72": "9.5",
      "74": "9.3",
      "76": "9.1",
      "78": "8.9",
      "80": "8.7",
      "85": "8.4",
      "90": "8.1",
      "95": "8.0",
      "100": "7.9"
    }
  },
  "高中一年级_女_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "高中一年级",
    "gender": "女",
    "display_order": 3,
    "scoring_table": {
      "10": "11.6",
      "20": "11.4",
      "30": "11.2",
      "40": "11.0",
      "50": "10.8",
      "60": "10.6",
      "62": "10.4",
      "64": "10.2",
      "66": "10.0",
      "68": "9.8",
      "70": "9.6",
      "72": "9.4",
      "74": "9.2",
      "76": "9.0",
      "78": "8.8",
      "80": "8.6",
      "85": "8.3",
      "90": "8.0",
      "95": "7.9",
      "100": "7.8"
    }
  },
  "高中二年级_女_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "高中二年级",
    "gender": "女",
    "display_order": 3,
    "scoring_table": {
      "10": "11.5",
      "20": "11.3",
      "30": "11.1",
      "40": "10.9",
      "50": "10.7",
      "60": "10.5",
      "62": "10.3",
      "64": "10.1",
      "66": "9.9",
      "68": "9.7",
      "70": "9.5",
      "72": "9.3",
      "74": "9.1",
      "76": "8.9",
      "78": "8.7",
      "80": "8.5",
      "85": "8.2",
      "90": "7.9",
      "95": "7.8",
      "100": "7.7"
    }
  },
  "高中三年级_女_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "高中三年级",
    "gender": "女",
    "display_order": 3,
    "scoring_table": {
      "10": "11.4",
      "20": "11.2",
      "30": "11.0",
      "40": "10.8",
      "50": "10.6",
      "60": "10.4",
      "62": "10.2",
      "64": "10.0",
      "66": "9.8",
      "68": "9.6",
      "70": "9.4",
      "72": "9.2",
      "74": "9.0",
      "76": "8.8",
      "78": "8.6",
      "80": "8.4",
      "85": "8.1",
      "90": "7.8",
      "95": "7.7",
      "100": "7.6"
    }
  },
  "大学一二年级_女_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "大学一二年级",
    "gender": "女",
    "display_order": 3,
    "scoring_table": {
      "10": "11.3",
      "20": "11.1",
      "30": "10.9",
      "40": "10.7",
      "50": "10.5",
      "60": "10.3",
      "62": "10.1",
      "64": "9.9",
      "66": "9.7",
      "68": "9.5",
      "70": "9.3",
      "72": "9.1",
      "74": "8.9",
      "76": "8.7",
      "78": "8.5",
      "80": "8.3",
      "85": "8",
      "90": "7.7",
      "95": "7.6",
      "100": "7.5"
    }
  },
  "大学三四年级_女_run_50m": {
    "item_code": "run_50m",
    "item_name": "50米跑",
    "grade": "大学三四年级",
    "gender": "女",
    "display_order": 3,
    "scoring_table": {
      "10": "11.2",
      "20": "11",
      "30": "10.8",
      "40": "10.6",
      "50": "10.4",
      "60": "10.2",
      "62": "10",
      "64": "9.8",
      "66": "9.6",
      "68": "9.4",
      "70": "9.2",
      "72": "9",
      "74": "8.8",
      "76": "8.6",
      "78": "8.4",
      "80": "8.2",
      "85": "7.9",
      "90": "7.6",
      "95": "7.5",
      "100": "7.4"
    }
  },
  "小学一年级_男_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "小学一年级",
    "gender": "男",
    "display_order": 4,
    "scoring_table": {
      "10": "-4.0",
      "20": "-3.2",
      "30": "-2.4",
      "40": "-1.6",
      "50": "-0.8",
      "60": "0.0",
      "62": "1.1",
      "64": "2.2",
      "66": "3.3",
      "68": "4.4",
      "70": "5.5",
      "72": "6.6",
      "74": "7.7",
      "76": "8.8",
      "78": "9.9",
      "80": "11.0",
      "85": "12.0",
      "90": "13.0",
      "95": "14.6",
      "100": "16.1"
    }
  },
  "小学二年级_男_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "小学二年级",
    "gender": "男",
    "display_order": 4,
    "scoring_table": {
      "10": "-4.4",
      "20": "-3.6",
      "30": "-2.8",
      "40": "-2.0",
      "50": "-1.2",
      "60": "-0.4",
      "62": "0.7",
      "64": "1.8",
      "66": "2.9",
      "68": "4.0",
      "70": "5.1",
      "72": "6.2",
      "74": "7.3",
      "76": "8.4",
      "78": "9.5",
      "80": "10.6",
      "85": "11.9",
      "90": "13.2",
      "95": "14.7",
      "100": "16.2"
    }
  },
  "小学三年级_男_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "小学三年级",
    "gender": "男",
    "display_order": 4,
    "scoring_table": {
      "10": "-4.8",
      "20": "-4.0",
      "30": "-3.2",
      "40": "-2.4",
      "50": "-1.6",
      "60": "-0.8",
      "62": "0.3",
      "64": "1.4",
      "66": "2.5",
      "68": "3.6",
      "70": "4.7",
      "72": "5.8",
      "74": "6.9",
      "76": "8.0",
      "78": "9.1",
      "80": "10.2",
      "85": "11.8",
      "90": "13.4",
      "95": "14.9",
      "100": "16.3"
    }
  },
  "小学四年级_男_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "小学四年级",
    "gender": "男",
    "display_order": 4,
    "scoring_table": {
      "10": "-7.2",
      "20": "-6.2",
      "30": "-5.2",
      "40": "-4.2",
      "50": "-3.2",
      "60": "-2.2",
      "62": "-1.0",
      "64": "0.2",
      "66": "1.4",
      "68": "2.6",
      "70": "3.8",
      "72": "5.0",
      "74": "6.2",
      "76": "7.4",
      "78": "8.6",
      "80": "9.8",
      "85": "11.7",
      "90": "13.6",
      "95": "15.0",
      "100": "16.4"
    }
  },
  "小学五年级_男_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "小学五年级",
    "gender": "男",
    "display_order": 4,
    "scoring_table": {
      "10": "-7.6",
      "20": "-6.6",
      "30": "-5.6",
      "40": "-4.6",
      "50": "-3.6",
      "60": "-2.6",
      "62": "-1.4",
      "64": "-0.2",
      "66": "1.0",
      "68": "2.2",
      "70": "3.4",
      "72": "4.6",
      "74": "5.8",
      "76": "7.0",
      "78": "8.2",
      "80": "9.4",
      "85": "11.6",
      "90": "13.8",
      "95": "15.2",
      "100": "16.5"
    }
  },
  "小学六年级_男_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "小学六年级",
    "gender": "男",
    "display_order": 4,
    "scoring_table": {
      "10": "-9.0",
      "20": "-8.0",
      "30": "-7.0",
      "40": "-6.0",
      "50": "-5.0",
      "60": "-4.0",
      "62": "-2.7",
      "64": "-1.4",
      "66": "-0.1",
      "68": "1.2",
      "70": "2.5",
      "72": "3.8",
      "74": "5.1",
      "76": "6.4",
      "78": "7.7",
      "80": "9.0",
      "85": "11.5",
      "90": "14.0",
      "95": "15.3",
      "100": "16.6"
    }
  },
  "初中一年级_男_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "初中一年级",
    "gender": "男",
    "display_order": 4,
    "scoring_table": {
      "10": "-8.6",
      "20": "-7.4",
      "30": "-6.2",
      "40": "-5.0",
      "50": "-3.8",
      "60": "-2.6",
      "62": "-1.3",
      "64": "0.0",
      "66": "1.3",
      "68": "2.6",
      "70": "3.9",
      "72": "5.2",
      "74": "6.5",
      "76": "7.8",
      "78": "9.1",
      "80": "10.4",
      "85": "12.3",
      "90": "14.2",
      "95": "15.9",
      "100": "17.6"
    }
  },
  "初中二年级_男_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "初中二年级",
    "gender": "男",
    "display_order": 4,
    "scoring_table": {
      "10": "-7.4",
      "20": "-6.2",
      "30": "-5.0",
      "40": "-3.8",
      "50": "-2.6",
      "60": "-1.4",
      "62": "-0.1",
      "64": "1.2",
      "66": "2.5",
      "68": "3.8",
      "70": "5.1",
      "72": "6.4",
      "74": "7.7",
      "76": "9.0",
      "78": "10.3",
      "80": "11.6",
      "85": "13.7",
      "90": "15.8",
      "95": "17.7",
      "100": "19.6"
    }
  },
  "初中三年级_男_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "初中三年级",
    "gender": "男",
    "display_order": 4,
    "scoring_table": {
      "10": "-6.2",
      "20": "-5.0",
      "30": "-3.8",
      "40": "-2.6",
      "50": "-1.4",
      "60": "-0.2",
      "62": "1.2",
      "64": "2.6",
      "66": "4.0",
      "68": "5.4",
      "70": "6.8",
      "72": "8.2",
      "74": "9.6",
      "76": "11.0",
      "78": "12.4",
      "80": "13.8",
      "85": "15.8",
      "90": "17.8",
      "95": "19.7",
      "100": "21.6"
    }
  },
  "高中一年级_男_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "高中一年级",
    "gender": "男",
    "display_order": 4,
    "scoring_table": {
      "10": "-4.0",
      "20": "-3.0",
      "30": "-2.0",
      "40": "-1.0",
      "50": "0.0",
      "60": "1.0",
      "62": "2.4",
      "64": "3.8",
      "66": "5.2",
      "68": "6.6",
      "70": "8.0",
      "72": "9.4",
      "74": "10.8",
      "76": "12.2",
      "78": "13.6",
      "80": "15.0",
      "85": "17.2",
      "90": "19.4",
      "95": "21.5",
      "100": "23.6"
    }
  },
  "高中二年级_男_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "高中二年级",
    "gender": "男",
    "display_order": 4,
    "scoring_table": {
      "10": "-2.9",
      "20": "-1.9",
      "30": "-0.9",
      "40": "0.1",
      "50": "1.1",
      "60": "2.1",
      "62": "3.5",
      "64": "4.9",
      "66": "6.3",
      "68": "7.7",
      "70": "9.1",
      "72": "10.5",
      "74": "11.9",
      "76": "13.3",
      "78": "14.7",
      "80": "16.1",
      "85": "18.3",
      "90": "20.5",
      "95": "22.4",
      "100": "24.3"
    }
  },
  "高中三年级_男_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "高中三年级",
    "gender": "男",
    "display_order": 4,
    "scoring_table": {
      "10": "-1.8",
      "20": "-0.8",
      "30": "0.2",
      "40": "1.2",
      "50": "2.2",
      "60": "3.2",
      "62": "4.6",
      "64": "6.0",
      "66": "7.4",
      "68": "8.8",
      "70": "10.2",
      "72": "11.6",
      "74": "13.0",
      "76": "14.4",
      "78": "15.8",
      "80": "17.2",
      "85": "19.1",
      "90": "21.0",
      "95": "22.8",
      "100": "24.6"
    }
  },
  "大学一二年级_男_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "大学一二年级",
    "gender": "男",
    "display_order": 4,
    "scoring_table": {
      "10": "-1.3",
      "20": "-0.3",
      "30": "0.7",
      "40": "1.7",
      "50": "2.7",
      "60": "3.7",
      "62": "5.1",
      "64": "6.5",
      "66": "7.9",
      "68": "9.3",
      "70": "10.7",
      "72": "12.1",
      "74": "13.5",
      "76": "14.9",
      "78": "16.3",
      "80": "17.7",
      "85": "19.5",
      "90": "21.3",
      "95": "23.1",
      "100": "24.9"
    }
  },
  "大学三四年级_男_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "大学三四年级",
    "gender": "男",
    "display_order": 4,
    "scoring_table": {
      "10": "-0.8",
      "20": "0.2",
      "30": "1.2",
      "40": "2.2",
      "50": "3.2",
      "60": "4.2",
      "62": "5.6",
      "64": "7",
      "66": "8.4",
      "68": "9.8",
      "70": "11.2",
      "72": "12.6",
      "74": "14",
      "76": "15.4",
      "78": "16.8",
      "80": "18.2",
      "85": "19.9",
      "90": "21.5",
      "95": "23.3",
      "100": "25.1"
    }
  },
  "小学一年级_女_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "小学一年级",
    "gender": "女",
    "display_order": 4,
    "scoring_table": {
      "10": "-1.6",
      "20": "-0.8",
      "30": "0.0",
      "40": "0.8",
      "50": "1.6",
      "60": "2.4",
      "62": "3.5",
      "64": "4.6",
      "66": "5.7",
      "68": "6.8",
      "70": "7.9",
      "72": "9.0",
      "74": "10.1",
      "76": "11.2",
      "78": "12.3",
      "80": "13.4",
      "85": "14.7",
      "90": "16.0",
      "95": "17.3",
      "100": "18.6"
    }
  },
  "小学二年级_女_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "小学二年级",
    "gender": "女",
    "display_order": 4,
    "scoring_table": {
      "10": "-1.7",
      "20": "-0.9",
      "30": "-0.1",
      "40": "0.7",
      "50": "1.5",
      "60": "2.3",
      "62": "3.4",
      "64": "4.5",
      "66": "5.6",
      "68": "6.7",
      "70": "7.8",
      "72": "8.9",
      "74": "10.0",
      "76": "11.1",
      "78": "12.2",
      "80": "13.3",
      "85": "14.8",
      "90": "16.3",
      "95": "17.6",
      "100": "18.9"
    }
  },
  "小学三年级_女_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "小学三年级",
    "gender": "女",
    "display_order": 4,
    "scoring_table": {
      "10": "-1.8",
      "20": "-1.0",
      "30": "-0.2",
      "40": "0.6",
      "50": "1.4",
      "60": "2.2",
      "62": "3.3",
      "64": "4.4",
      "66": "5.5",
      "68": "6.6",
      "70": "7.7",
      "72": "8.8",
      "74": "9.9",
      "76": "11.0",
      "78": "12.1",
      "80": "13.2",
      "85": "14.9",
      "90": "16.6",
      "95": "17.9",
      "100": "19.2"
    }
  },
  "小学四年级_女_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "小学四年级",
    "gender": "女",
    "display_order": 4,
    "scoring_table": {
      "10": "-1.9",
      "20": "-1.1",
      "30": "-0.3",
      "40": "0.5",
      "50": "1.3",
      "60": "2.1",
      "62": "3.2",
      "64": "4.3",
      "66": "5.4",
      "68": "6.5",
      "70": "7.6",
      "72": "8.7",
      "74": "9.8",
      "76": "10.9",
      "78": "12.0",
      "80": "13.1",
      "85": "15.0",
      "90": "16.9",
      "95": "18.1",
      "100": "19.5"
    }
  },
  "小学五年级_女_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "小学五年级",
    "gender": "女",
    "display_order": 4,
    "scoring_table": {
      "10": "-2.0",
      "20": "-1.2",
      "30": "-0.4",
      "40": "0.4",
      "50": "1.2",
      "60": "2.0",
      "62": "3.1",
      "64": "4.2",
      "66": "5.3",
      "68": "6.4",
      "70": "7.5",
      "72": "8.6",
      "74": "9.7",
      "76": "10.8",
      "78": "11.9",
      "80": "13.0",
      "85": "15.1",
      "90": "17.2",
      "95": "18.5",
      "100": "19.8"
    }
  },
  "小学六年级_女_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "小学六年级",
    "gender": "女",
    "display_order": 4,
    "scoring_table": {
      "10": "-2.1",
      "20": "-1.3",
      "30": "-0.5",
      "40": "0.3",
      "50": "1.1",
      "60": "1.9",
      "62": "3.0",
      "64": "4.1",
      "66": "5.2",
      "68": "6.3",
      "70": "7.4",
      "72": "8.5",
      "74": "9.6",
      "76": "10.7",
      "78": "11.8",
      "80": "12.9",
      "85": "15.2",
      "90": "17.5",
      "95": "18.7",
      "100": "19.9"
    }
  },
  "初中一年级_女_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "初中一年级",
    "gender": "女",
    "display_order": 4,
    "scoring_table": {
      "10": "-2.0",
      "20": "-1.2",
      "30": "-0.4",
      "40": "0.4",
      "50": "1.2",
      "60": "2.0",
      "62": "3.3",
      "64": "4.6",
      "66": "5.9",
      "68": "7.2",
      "70": "8.5",
      "72": "9.8",
      "74": "11.1",
      "76": "12.4",
      "78": "13.7",
      "80": "15.0",
      "85": "16.7",
      "90": "18.4",
      "95": "20.1",
      "100": "21.8"
    }
  },
  "初中二年级_女_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "初中二年级",
    "gender": "女",
    "display_order": 4,
    "scoring_table": {
      "10": "-1.1",
      "20": "-0.3",
      "30": "0.5",
      "40": "1.3",
      "50": "2.1",
      "60": "2.9",
      "62": "4.2",
      "64": "5.5",
      "66": "6.8",
      "68": "8.1",
      "70": "9.4",
      "72": "10.7",
      "74": "12.0",
      "76": "13.3",
      "78": "14.6",
      "80": "15.9",
      "85": "17.6",
      "90": "19.3",
      "95": "21.0",
      "100": "22.7"
    }
  },
  "初中三年级_女_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "初中三年级",
    "gender": "女",
    "display_order": 4,
    "scoring_table": {
      "10": "-0.3",
      "20": "0.5",
      "30": "1.3",
      "40": "2.1",
      "50": "2.9",
      "60": "3.7",
      "62": "5.0",
      "64": "6.3",
      "66": "7.6",
      "68": "8.9",
      "70": "10.2",
      "72": "11.5",
      "74": "12.8",
      "76": "14.1",
      "78": "15.4",
      "80": "16.7",
      "85": "18.4",
      "90": "20.1",
      "95": "21.8",
      "100": "23.5"
    }
  },
  "高中一年级_女_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "高中一年级",
    "gender": "女",
    "display_order": 4,
    "scoring_table": {
      "10": "0.4",
      "20": "1.2",
      "30": "2.0",
      "40": "2.8",
      "50": "3.6",
      "60": "4.4",
      "62": "5.7",
      "64": "7.0",
      "66": "8.3",
      "68": "9.6",
      "70": "10.9",
      "72": "12.2",
      "74": "13.5",
      "76": "14.8",
      "78": "16.1",
      "80": "17.4",
      "85": "19.1",
      "90": "20.8",
      "95": "22.5",
      "100": "24.2"
    }
  },
  "高中二年级_女_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "高中二年级",
    "gender": "女",
    "display_order": 4,
    "scoring_table": {
      "10": "1.0",
      "20": "1.8",
      "30": "2.6",
      "40": "3.4",
      "50": "4.2",
      "60": "5.0",
      "62": "6.3",
      "64": "7.6",
      "66": "8.9",
      "68": "10.2",
      "70": "11.5",
      "72": "12.8",
      "74": "14.1",
      "76": "15.4",
      "78": "16.7",
      "80": "18.0",
      "85": "19.7",
      "90": "21.4",
      "95": "23.1",
      "100": "24.8"
    }
  },
  "高中三年级_女_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "高中三年级",
    "gender": "女",
    "display_order": 4,
    "scoring_table": {
      "10": "1.5",
      "20": "2.3",
      "30": "3.1",
      "40": "3.9",
      "50": "4.7",
      "60": "5.5",
      "62": "6.8",
      "64": "8.1",
      "66": "9.4",
      "68": "10.7",
      "70": "12.0",
      "72": "13.3",
      "74": "14.6",
      "76": "15.9",
      "78": "17.2",
      "80": "18.5",
      "85": "20.2",
      "90": "21.9",
      "95": "23.6",
      "100": "25.3"
    }
  },
  "大学一二年级_女_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "大学一二年级",
    "gender": "女",
    "display_order": 4,
    "scoring_table": {
      "10": "2",
      "20": "2.8",
      "30": "3.6",
      "40": "4.4",
      "50": "5.2",
      "60": "6",
      "62": "7.3",
      "64": "8.6",
      "66": "9.9",
      "68": "11.2",
      "70": "12.5",
      "72": "13.8",
      "74": "15.1",
      "76": "16.4",
      "78": "17.7",
      "80": "19",
      "85": "20.6",
      "90": "22.2",
      "95": "24",
      "100": "25.8"
    }
  },
  "大学三四年级_女_sit_and_reach": {
    "item_code": "sit_and_reach",
    "item_name": "坐位体前屈",
    "grade": "大学三四年级",
    "gender": "女",
    "display_order": 4,
    "scoring_table": {
      "10": "2.5",
      "20": "3.3",
      "30": "4.1",
      "40": "4.9",
      "50": "5.7",
      "60": "6.5",
      "62": "7.8",
      "64": "9.1",
      "66": "10.4",
      "68": "11.7",
      "70": "13",
      "72": "14.3",
      "74": "15.6",
      "76": "16.9",
      "78": "18.2",
      "80": "19.5",
      "85": "21",
      "90": "22.4",
      "95": "24.4",
      "100": "26.3"
    }
  },
  "小学一年级_男_skip_rope": {
    "item_code": "skip_rope",
    "item_name": "一分钟跳绳",
    "grade": "小学一年级",
    "gender": "男",
    "display_order": 5,
    "scoring_table": {
      "10": "2.0",
      "20": "5.0",
      "30": "8.0",
      "40": "11.0",
      "50": "14.0",
      "60": "17.0",
      "62": "24.0",
      "64": "31.0",
      "66": "38.0",
      "68": "45.0",
      "70": "52.0",
      "72": "59.0",
      "74": "66.0",
      "76": "73.0",
      "78": "80.0",
      "80": "87.0",
      "85": "93.0",
      "90": "99.0",
      "95": "104.0",
      "100": "109.0"
    }
  },
  "小学二年级_男_skip_rope": {
    "item_code": "skip_rope",
    "item_name": "一分钟跳绳",
    "grade": "小学二年级",
    "gender": "男",
    "display_order": 5,
    "scoring_table": {
      "10": "10.0",
      "20": "13.0",
      "30": "16.0",
      "40": "19.0",
      "50": "22.0",
      "60": "25.0",
      "62": "32.0",
      "64": "39.0",
      "66": "46.0",
      "68": "53.0",
      "70": "60.0",
      "72": "67.0",
      "74": "74.0",
      "76": "81.0",
      "78": "88.0",
      "80": "95.0",
      "85": "101.0",
      "90": "107.0",
      "95": "112.0",
      "100": "117.0"
    }
  },
  "小学三年级_男_skip_rope": {
    "item_code": "skip_rope",
    "item_name": "一分钟跳绳",
    "grade": "小学三年级",
    "gender": "男",
    "display_order": 5,
    "scoring_table": {
      "10": "19.0",
      "20": "22.0",
      "30": "25.0",
      "40": "28.0",
      "50": "31.0",
      "60": "34.0",
      "62": "41.0",
      "64": "48.0",
      "66": "55.0",
      "68": "62.0",
      "70": "69.0",
      "72": "76.0",
      "74": "83.0",
      "76": "90.0",
      "78": "97.0",
      "80": "104.0",
      "85": "110.0",
      "90": "116.0",
      "95": "121.0",
      "100": "126.0"
    }
  },
  "小学四年级_男_skip_rope": {
    "item_code": "skip_rope",
    "item_name": "一分钟跳绳",
    "grade": "小学四年级",
    "gender": "男",
    "display_order": 5,
    "scoring_table": {
      "10": "30.0",
      "20": "33.0",
      "30": "36.0",
      "40": "39.0",
      "50": "42.0",
      "60": "45.0",
      "62": "52.0",
      "64": "59.0",
      "66": "66.0",
      "68": "73.0",
      "70": "80.0",
      "72": "87.0",
      "74": "94.0",
      "76": "101.0",
      "78": "108.0",
      "80": "115.0",
      "85": "121.0",
      "90": "127.0",
      "95": "132.0",
      "100": "137.0"
    }
  },
  "小学五年级_男_skip_rope": {
    "item_code": "skip_rope",
    "item_name": "一分钟跳绳",
    "grade": "小学五年级",
    "gender": "男",
    "display_order": 5,
    "scoring_table": {
      "10": "41.0",
      "20": "44.0",
      "30": "47.0",
      "40": "50.0",
      "50": "53.0",
      "60": "56.0",
      "62": "63.0",
      "64": "70.0",
      "66": "77.0",
      "68": "84.0",
      "70": "91.0",
      "72": "98.0",
      "74": "105.0",
      "76": "112.0",
      "78": "119.0",
      "80": "126.0",
      "85": "132.0",
      "90": "138.0",
      "95": "143.0",
      "100": "148.0"
    }
  },
  "小学六年级_男_skip_rope": {
    "item_code": "skip_rope",
    "item_name": "一分钟跳绳",
    "grade": "小学六年级",
    "gender": "男",
    "display_order": 5,
    "scoring_table": {
      "10": "50.0",
      "20": "53.0",
      "30": "56.0",
      "40": "59.0",
      "50": "62.0",
      "60": "65.0",
      "62": "72.0",
      "64": "79.0",
      "66": "86.0",
      "68": "93.0",
      "70": "100.0",
      "72": "107.0",
      "74": "114.0",
      "76": "121.0",
      "78": "128.0",
      "80": "135.0",
      "85": "141.0",
      "90": "147.0",
      "95": "152.0",
      "100": "157.0"
    }
  },
  "小学一年级_女_skip_rope": {
    "item_code": "skip_rope",
    "item_name": "一分钟跳绳",
    "grade": "小学一年级",
    "gender": "女",
    "display_order": 5,
    "scoring_table": {
      "10": "2.0",
      "20": "5.0",
      "30": "8.0",
      "40": "11.0",
      "50": "14.0",
      "60": "17.0",
      "62": "24.0",
      "64": "31.0",
      "66": "38.0",
      "68": "45.0",
      "70": "52.0",
      "72": "59.0",
      "74": "66.0",
      "76": "73.0",
      "78": "80.0",
      "80": "87.0",
      "85": "95.0",
      "90": "103.0",
      "95": "110.0",
      "100": "117.0"
    }
  },
  "小学二年级_女_skip_rope": {
    "item_code": "skip_rope",
    "item_name": "一分钟跳绳",
    "grade": "小学二年级",
    "gender": "女",
    "display_order": 5,
    "scoring_table": {
      "10": "12.0",
      "20": "15.0",
      "30": "18.0",
      "40": "21.0",
      "50": "24.0",
      "60": "27.0",
      "62": "34.0",
      "64": "41.0",
      "66": "48.0",
      "68": "55.0",
      "70": "62.0",
      "72": "69.0",
      "74": "76.0",
      "76": "83.0",
      "78": "90.0",
      "80": "97.0",
      "85": "105.0",
      "90": "113.0",
      "95": "120.0",
      "100": "127.0"
    }
  },
  "小学三年级_女_skip_rope": {
    "item_code": "skip_rope",
    "item_name": "一分钟跳绳",
    "grade": "小学三年级",
    "gender": "女",
    "display_order": 5,
    "scoring_table": {
      "10": "24.0",
      "20": "27.0",
      "30": "30.0",
      "40": "33.0",
      "50": "36.0",
      "60": "39.0",
      "62": "46.0",
      "64": "53.0",
      "66": "60.0",
      "68": "67.0",
      "70": "74.0",
      "72": "81.0",
      "74": "88.0",
      "76": "95.0",
      "78": "102.0",
      "80": "109.0",
      "85": "117.0",
      "90": "125.0",
      "95": "132.0",
      "100": "139.0"
    }
  },
  "小学四年级_女_skip_rope": {
    "item_code": "skip_rope",
    "item_name": "一分钟跳绳",
    "grade": "小学四年级",
    "gender": "女",
    "display_order": 5,
    "scoring_table": {
      "10": "34.0",
      "20": "37.0",
      "30": "40.0",
      "40": "43.0",
      "50": "46.0",
      "60": "49.0",
      "62": "56.0",
      "64": "63.0",
      "66": "70.0",
      "68": "77.0",
      "70": "84.0",
      "72": "91.0",
      "74": "98.0",
      "76": "105.0",
      "78": "112.0",
      "80": "119.0",
      "85": "127.0",
      "90": "135.0",
      "95": "142.0",
      "100": "149.0"
    }
  },
  "小学五年级_女_skip_rope": {
    "item_code": "skip_rope",
    "item_name": "一分钟跳绳",
    "grade": "小学五年级",
    "gender": "女",
    "display_order": 5,
    "scoring_table": {
      "10": "43.0",
      "20": "46.0",
      "30": "49.0",
      "40": "52.0",
      "50": "55.0",
      "60": "58.0",
      "62": "65.0",
      "64": "72.0",
      "66": "79.0",
      "68": "86.0",
      "70": "93.0",
      "72": "100.0",
      "74": "107.0",
      "76": "114.0",
      "78": "121.0",
      "80": "128.0",
      "85": "136.0",
      "90": "144.0",
      "95": "151.0",
      "100": "158.0"
    }
  },
  "小学六年级_女_skip_rope": {
    "item_code": "skip_rope",
    "item_name": "一分钟跳绳",
    "grade": "小学六年级",
    "gender": "女",
    "display_order": 5,
    "scoring_table": {
      "10": "51.0",
      "20": "54.0",
      "30": "57.0",
      "40": "60.0",
      "50": "63.0",
      "60": "66.0",
      "62": "73.0",
      "64": "80.0",
      "66": "87.0",
      "68": "94.0",
      "70": "101.0",
      "72": "108.0",
      "74": "115.0",
      "76": "122.0",
      "78": "129.0",
      "80": "136.0",
      "85": "144.0",
      "90": "152.0",
      "95": "159.0",
      "100": "166.0"
    }
  },
  "初中一年级_男_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "初中一年级",
    "gender": "男",
    "display_order": 8,
    "scoring_table": {
      "10": "130.0",
      "20": "135.0",
      "30": "140.0",
      "40": "145.0",
      "50": "150.0",
      "60": "155.0",
      "62": "159.0",
      "64": "163.0",
      "66": "167.0",
      "68": "171.0",
      "70": "175.0",
      "72": "179.0",
      "74": "183.0",
      "76": "187.0",
      "78": "191.0",
      "80": "195.0",
      "85": "203.0",
      "90": "211.0",
      "95": "218.0",
      "100": "225.0"
    }
  },
  "初中二年级_男_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "初中二年级",
    "gender": "男",
    "display_order": 8,
    "scoring_table": {
      "10": "145.0",
      "20": "150.0",
      "30": "155.0",
      "40": "160.0",
      "50": "165.0",
      "60": "170.0",
      "62": "174.0",
      "64": "178.0",
      "66": "182.0",
      "68": "186.0",
      "70": "190.0",
      "72": "194.0",
      "74": "198.0",
      "76": "202.0",
      "78": "206.0",
      "80": "210.0",
      "85": "218.0",
      "90": "226.0",
      "95": "233.0",
      "100": "240.0"
    }
  },
  "初中三年级_男_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "初中三年级",
    "gender": "男",
    "display_order": 8,
    "scoring_table": {
      "10": "160.0",
      "20": "165.0",
      "30": "170.0",
      "40": "175.0",
      "50": "180.0",
      "60": "185.0",
      "62": "189.0",
      "64": "193.0",
      "66": "197.0",
      "68": "201.0",
      "70": "205.0",
      "72": "209.0",
      "74": "213.0",
      "76": "217.0",
      "78": "221.0",
      "80": "225.0",
      "85": "233.0",
      "90": "240.0",
      "95": "245.0",
      "100": "250.0"
    }
  },
  "高中一年级_男_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "高中一年级",
    "gender": "男",
    "display_order": 8,
    "scoring_table": {
      "10": "170.0",
      "20": "175.0",
      "30": "180.0",
      "40": "185.0",
      "50": "190.0",
      "60": "195.0",
      "62": "199.0",
      "64": "203.0",
      "66": "207.0",
      "68": "211.0",
      "70": "215.0",
      "72": "219.0",
      "74": "223.0",
      "76": "227.0",
      "78": "231.0",
      "80": "235.0",
      "85": "243.0",
      "90": "250.0",
      "95": "255.0",
      "100": "260.0"
    }
  },
  "高中二年级_男_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "高中二年级",
    "gender": "男",
    "display_order": 8,
    "scoring_table": {
      "10": "175.0",
      "20": "180.0",
      "30": "185.0",
      "40": "190.0",
      "50": "195.0",
      "60": "200.0",
      "62": "204.0",
      "64": "208.0",
      "66": "212.0",
      "68": "216.0",
      "70": "220.0",
      "72": "224.0",
      "74": "228.0",
      "76": "232.0",
      "78": "236.0",
      "80": "240.0",
      "85": "248.0",
      "90": "255.0",
      "95": "260.0",
      "100": "265.0"
    }
  },
  "高中三年级_男_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "高中三年级",
    "gender": "男",
    "display_order": 8,
    "scoring_table": {
      "10": "180.0",
      "20": "185.0",
      "30": "190.0",
      "40": "195.0",
      "50": "200.0",
      "60": "205.0",
      "62": "209.0",
      "64": "213.0",
      "66": "217.0",
      "68": "221.0",
      "70": "225.0",
      "72": "229.0",
      "74": "233.0",
      "76": "237.0",
      "78": "241.0",
      "80": "245.0",
      "85": "253.0",
      "90": "260.0",
      "95": "265.0",
      "100": "270.0"
    }
  },
  "大学一二年级_男_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "大学一二年级",
    "gender": "男",
    "display_order": 8,
    "scoring_table": {
      "10": "183.0",
      "20": "188.0",
      "30": "193.0",
      "40": "198.0",
      "50": "203.0",
      "60": "208.0",
      "62": "212.0",
      "64": "216.0",
      "66": "220.0",
      "68": "224.0",
      "70": "228.0",
      "72": "232.0",
      "74": "236.0",
      "76": "240.0",
      "78": "244.0",
      "80": "248.0",
      "85": "256.0",
      "90": "263.0",
      "95": "268.0",
      "100": "273.0"
    }
  },
  "大学三四年级_男_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "大学三四年级",
    "gender": "男",
    "display_order": 8,
    "scoring_table": {
      "10": "185.0",
      "20": "190.0",
      "30": "195.0",
      "40": "200.0",
      "50": "205.0",
      "60": "210.0",
      "62": "214.0",
      "64": "218.0",
      "66": "222.0",
      "68": "226.0",
      "70": "230.0",
      "72": "234.0",
      "74": "238.0",
      "76": "242.0",
      "78": "246.0",
      "80": "250.0",
      "85": "258.0",
      "90": "265.0",
      "95": "270.0",
      "100": "275.0"
    }
  },
  "初中一年级_女_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "初中一年级",
    "gender": "女",
    "display_order": 8,
    "scoring_table": {
      "10": "115.0",
      "20": "120.0",
      "30": "125.0",
      "40": "130.0",
      "50": "135.0",
      "60": "140.0",
      "62": "143.0",
      "64": "146.0",
      "66": "149.0",
      "68": "152.0",
      "70": "155.0",
      "72": "158.0",
      "74": "161.0",
      "76": "164.0",
      "78": "167.0",
      "80": "170.0",
      "85": "177.0",
      "90": "184.0",
      "95": "190.0",
      "100": "196.0"
    }
  },
  "初中二年级_女_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "初中二年级",
    "gender": "女",
    "display_order": 8,
    "scoring_table": {
      "10": "119.0",
      "20": "124.0",
      "30": "129.0",
      "40": "134.0",
      "50": "139.0",
      "60": "144.0",
      "62": "147.0",
      "64": "150.0",
      "66": "153.0",
      "68": "156.0",
      "70": "159.0",
      "72": "162.0",
      "74": "165.0",
      "76": "168.0",
      "78": "171.0",
      "80": "174.0",
      "85": "181.0",
      "90": "188.0",
      "95": "194.0",
      "100": "200.0"
    }
  },
  "初中三年级_女_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "初中三年级",
    "gender": "女",
    "display_order": 8,
    "scoring_table": {
      "10": "121.0",
      "20": "126.0",
      "30": "131.0",
      "40": "136.0",
      "50": "141.0",
      "60": "146.0",
      "62": "149.0",
      "64": "152.0",
      "66": "155.0",
      "68": "158.0",
      "70": "161.0",
      "72": "164.0",
      "74": "167.0",
      "76": "170.0",
      "78": "173.0",
      "80": "176.0",
      "85": "183.0",
      "90": "190.0",
      "95": "196.0",
      "100": "202.0"
    }
  },
  "高中一年级_女_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "高中一年级",
    "gender": "女",
    "display_order": 8,
    "scoring_table": {
      "10": "123.0",
      "20": "128.0",
      "30": "133.0",
      "40": "138.0",
      "50": "143.0",
      "60": "148.0",
      "62": "151.0",
      "64": "154.0",
      "66": "157.0",
      "68": "160.0",
      "70": "163.0",
      "72": "166.0",
      "74": "169.0",
      "76": "172.0",
      "78": "175.0",
      "80": "178.0",
      "85": "185.0",
      "90": "192.0",
      "95": "198.0",
      "100": "204.0"
    }
  },
  "高中二年级_女_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "高中二年级",
    "gender": "女",
    "display_order": 8,
    "scoring_table": {
      "10": "124.0",
      "20": "129.0",
      "30": "134.0",
      "40": "139.0",
      "50": "144.0",
      "60": "149.0",
      "62": "152.0",
      "64": "155.0",
      "66": "158.0",
      "68": "161.0",
      "70": "164.0",
      "72": "167.0",
      "74": "170.0",
      "76": "173.0",
      "78": "176.0",
      "80": "179.0",
      "85": "186.0",
      "90": "193.0",
      "95": "199.0",
      "100": "205.0"
    }
  },
  "高中三年级_女_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "高中三年级",
    "gender": "女",
    "display_order": 8,
    "scoring_table": {
      "10": "125.0",
      "20": "130.0",
      "30": "135.0",
      "40": "140.0",
      "50": "145.0",
      "60": "150.0",
      "62": "153.0",
      "64": "156.0",
      "66": "159.0",
      "68": "162.0",
      "70": "165.0",
      "72": "168.0",
      "74": "171.0",
      "76": "174.0",
      "78": "177.0",
      "80": "180.0",
      "85": "187.0",
      "90": "194.0",
      "95": "200.0",
      "100": "206.0"
    }
  },
  "大学一二年级_女_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "大学一二年级",
    "gender": "女",
    "display_order": 8,
    "scoring_table": {
      "10": "126.0",
      "20": "131.0",
      "30": "136.0",
      "40": "141.0",
      "50": "146.0",
      "60": "151.0",
      "62": "154.0",
      "64": "157.0",
      "66": "160.0",
      "68": "163.0",
      "70": "166.0",
      "72": "169.0",
      "74": "172.0",
      "76": "175.0",
      "78": "178.0",
      "80": "181.0",
      "85": "188.0",
      "90": "195.0",
      "95": "201.0",
      "100": "207.0"
    }
  },
  "大学三四年级_女_standing_long_jump": {
    "item_code": "standing_long_jump",
    "item_name": "立定跳远",
    "grade": "大学三四年级",
    "gender": "女",
    "display_order": 8,
    "scoring_table": {
      "10": "127.0",
      "20": "132.0",
      "30": "137.0",
      "40": "142.0",
      "50": "147.0",
      "60": "152.0",
      "62": "155.0",
      "64": "158.0",
      "66": "161.0",
      "68": "164.0",
      "70": "167.0",
      "72": "170.0",
      "74": "173.0",
      "76": "176.0",
      "78": "179.0",
      "80": "182.0",
      "85": "189.0",
      "90": "196.0",
      "95": "202.0",
      "100": "208.0"
    }
  },
  "初中一年级_男_pull_up": {
    "item_code": "pull_up",
    "item_name": "引体向上",
    "grade": "初中一年级",
    "gender": "男",
    "display_order": 6,
    "scoring_table": {
      "30": "1.0",
      "40": "2.0",
      "50": "3.0",
      "60": "4.0",
      "64": "5.0",
      "68": "6.0",
      "72": "7.0",
      "76": "8.0",
      "80": "9.0",
      "85": "10.0",
      "90": "11.0",
      "95": "12.0",
      "100": "13.0"
    }
  },
  "初中二年级_男_pull_up": {
    "item_code": "pull_up",
    "item_name": "引体向上",
    "grade": "初中二年级",
    "gender": "男",
    "display_order": 6,
    "scoring_table": {
      "20": "1.0",
      "30": "2.0",
      "40": "3.0",
      "50": "4.0",
      "60": "5.0",
      "64": "6.0",
      "68": "7.0",
      "72": "8.0",
      "76": "9.0",
      "80": "10.0",
      "85": "11.0",
      "90": "12.0",
      "95": "13.0",
      "100": "14.0"
    }
  },
  "初中三年级_男_pull_up": {
    "item_code": "pull_up",
    "item_name": "引体向上",
    "grade": "初中三年级",
    "gender": "男",
    "display_order": 6,
    "scoring_table": {
      "10": "1.0",
      "20": "2.0",
      "30": "3.0",
      "40": "4.0",
      "50": "5.0",
      "60": "6.0",
      "64": "7.0",
      "68": "8.0",
      "72": "9.0",
      "76": "10.0",
      "80": "11.0",
      "85": "12.0",
      "90": "13.0",
      "95": "14.0",
      "100": "15.0"
    }
  },
  "高中一年级_男_pull_up": {
    "item_code": "pull_up",
    "item_name": "引体向上",
    "grade": "高中一年级",
    "gender": "男",
    "display_order": 6,
    "scoring_table": {
      "10": "2.0",
      "20": "3.0",
      "30": "4.0",
      "40": "5.0",
      "50": "6.0",
      "60": "7.0",
      "64": "8.0",
      "68": "9.0",
      "72": "10.0",
      "76": "11.0",
      "80": "12.0",
      "85": "13.0",
      "90": "14.0",
      "95": "15.0",
      "100": "16.0"
    }
  },
  "高中二年级_男_pull_up": {
    "item_code": "pull_up",
    "item_name": "引体向上",
    "grade": "高中二年级",
    "gender": "男",
    "display_order": 6,
    "scoring_table": {
      "10": "3.0",
      "20": "4.0",
      "30": "5.0",
      "40": "6.0",
      "50": "7.0",
      "60": "8.0",
      "64": "9.0",
      "68": "10.0",
      "72": "11.0",
      "76": "12.0",
      "80": "13.0",
      "85": "14.0",
      "90": "15.0",
      "95": "16.0",
      "100": "17.0"
    }
  },
  "高中三年级_男_pull_up": {
    "item_code": "pull_up",
    "item_name": "引体向上",
    "grade": "高中三年级",
    "gender": "男",
    "display_order": 6,
    "scoring_table": {
      "10": "4.0",
      "20": "5.0",
      "30": "6.0",
      "40": "7.0",
      "50": "8.0",
      "60": "9.0",
      "64": "10.0",
      "68": "11.0",
      "72": "12.0",
      "76": "13.0",
      "80": "14.0",
      "85": "15.0",
      "90": "16.0",
      "95": "17.0",
      "100": "18.0"
    }
  },
  "大学一二年级_男_pull_up": {
    "item_code": "pull_up",
    "item_name": "引体向上",
    "grade": "大学一二年级",
    "gender": "男",
    "display_order": 6,
    "scoring_table": {
      "10": "5",
      "20": "6",
      "30": "7",
      "40": "8",
      "50": "9",
      "60": "10",
      "64": "11",
      "68": "12",
      "72": "13",
      "76": "14",
      "80": "15",
      "85": "16",
      "90": "17",
      "95": "18",
      "100": "19"
    }
  },
  "大学三四年级_男_pull_up": {
    "item_code": "pull_up",
    "item_name": "引体向上",
    "grade": "大学三四年级",
    "gender": "男",
    "display_order": 6,
    "scoring_table": {
      "10": "6",
      "20": "7",
      "30": "8",
      "40": "9",
      "50": "10",
      "60": "11",
      "64": "12",
      "68": "13",
      "72": "14",
      "76": "15",
      "80": "16",
      "85": "17",
      "90": "18",
      "95": "19",
      "100": "20"
    }
  },
  "小学三年级_女_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "小学三年级",
    "gender": "女",
    "display_order": 6,
    "scoring_table": {
      "10": "6.0",
      "20": "8.0",
      "30": "10.0",
      "40": "12.0",
      "50": "14.0",
      "60": "16.0",
      "62": "18.0",
      "64": "20.0",
      "66": "22.0",
      "68": "24.0",
      "70": "26.0",
      "72": "28.0",
      "74": "30.0",
      "76": "32.0",
      "78": "34.0",
      "80": "36.0",
      "85": "39.0",
      "90": "42.0",
      "95": "44.0",
      "100": "46.0"
    }
  },
  "小学四年级_女_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "小学四年级",
    "gender": "女",
    "display_order": 6,
    "scoring_table": {
      "10": "7.0",
      "20": "9.0",
      "30": "11.0",
      "40": "13.0",
      "50": "15.0",
      "60": "17.0",
      "62": "19.0",
      "64": "21.0",
      "66": "23.0",
      "68": "25.0",
      "70": "27.0",
      "72": "29.0",
      "74": "31.0",
      "76": "33.0",
      "78": "35.0",
      "80": "37.0",
      "85": "40.0",
      "90": "43.0",
      "95": "45.0",
      "100": "47.0"
    }
  },
  "小学五年级_女_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "小学五年级",
    "gender": "女",
    "display_order": 6,
    "scoring_table": {
      "10": "8.0",
      "20": "10.0",
      "30": "12.0",
      "40": "14.0",
      "50": "16.0",
      "60": "18.0",
      "62": "20.0",
      "64": "22.0",
      "66": "24.0",
      "68": "26.0",
      "70": "28.0",
      "72": "30.0",
      "74": "32.0",
      "76": "34.0",
      "78": "36.0",
      "80": "38.0",
      "85": "41.0",
      "90": "44.0",
      "95": "46.0",
      "100": "48.0"
    }
  },
  "小学六年级_女_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "小学六年级",
    "gender": "女",
    "display_order": 6,
    "scoring_table": {
      "10": "9.0",
      "20": "11.0",
      "30": "13.0",
      "40": "15.0",
      "50": "17.0",
      "60": "19.0",
      "62": "21.0",
      "64": "23.0",
      "66": "25.0",
      "68": "27.0",
      "70": "29.0",
      "72": "31.0",
      "74": "33.0",
      "76": "35.0",
      "78": "37.0",
      "80": "39.0",
      "85": "42.0",
      "90": "45.0",
      "95": "47.0",
      "100": "49.0"
    }
  },
  "初中一年级_女_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "初中一年级",
    "gender": "女",
    "display_order": 6,
    "scoring_table": {
      "10": "10.0",
      "20": "12.0",
      "30": "14.0",
      "40": "16.0",
      "50": "18.0",
      "60": "20.0",
      "62": "22.0",
      "64": "24.0",
      "66": "26.0",
      "68": "28.0",
      "70": "30.0",
      "72": "32.0",
      "74": "34.0",
      "76": "36.0",
      "78": "38.0",
      "80": "40.0",
      "85": "43.0",
      "90": "46.0",
      "95": "48.0",
      "100": "50.0"
    }
  },
  "初中二年级_女_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "初中二年级",
    "gender": "女",
    "display_order": 6,
    "scoring_table": {
      "10": "11.0",
      "20": "13.0",
      "30": "15.0",
      "40": "17.0",
      "50": "19.0",
      "60": "21.0",
      "62": "23.0",
      "64": "25.0",
      "66": "27.0",
      "68": "29.0",
      "70": "31.0",
      "72": "33.0",
      "74": "35.0",
      "76": "37.0",
      "78": "39.0",
      "80": "41.0",
      "85": "44.0",
      "90": "47.0",
      "95": "49.0",
      "100": "51.0"
    }
  },
  "初中三年级_女_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "初中三年级",
    "gender": "女",
    "display_order": 6,
    "scoring_table": {
      "10": "12.0",
      "20": "14.0",
      "30": "16.0",
      "40": "18.0",
      "50": "20.0",
      "60": "22.0",
      "62": "24.0",
      "64": "26.0",
      "66": "28.0",
      "68": "30.0",
      "70": "32.0",
      "72": "34.0",
      "74": "36.0",
      "76": "38.0",
      "78": "40.0",
      "80": "42.0",
      "85": "45.0",
      "90": "48.0",
      "95": "50.0",
      "100": "52.0"
    }
  },
  "高中一年级_女_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "高中一年级",
    "gender": "女",
    "display_order": 6,
    "scoring_table": {
      "10": "13.0",
      "20": "15.0",
      "30": "17.0",
      "40": "19.0",
      "50": "21.0",
      "60": "23.0",
      "62": "25.0",
      "64": "27.0",
      "66": "29.0",
      "68": "31.0",
      "70": "33.0",
      "72": "35.0",
      "74": "37.0",
      "76": "39.0",
      "78": "41.0",
      "80": "43.0",
      "85": "46.0",
      "90": "49.0",
      "95": "51.0",
      "100": "53.0"
    }
  },
  "高中二年级_女_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "高中二年级",
    "gender": "女",
    "display_order": 6,
    "scoring_table": {
      "10": "14.0",
      "20": "16.0",
      "30": "18.0",
      "40": "20.0",
      "50": "22.0",
      "60": "24.0",
      "62": "26.0",
      "64": "28.0",
      "66": "30.0",
      "68": "32.0",
      "70": "34.0",
      "72": "36.0",
      "74": "38.0",
      "76": "40.0",
      "78": "42.0",
      "80": "44.0",
      "85": "47.0",
      "90": "50.0",
      "95": "52.0",
      "100": "54.0"
    }
  },
  "高中三年级_女_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "高中三年级",
    "gender": "女",
    "display_order": 6,
    "scoring_table": {
      "10": "15.0",
      "20": "17.0",
      "30": "19.0",
      "40": "21.0",
      "50": "23.0",
      "60": "25.0",
      "62": "27.0",
      "64": "29.0",
      "66": "31.0",
      "68": "33.0",
      "70": "35.0",
      "72": "37.0",
      "74": "39.0",
      "76": "41.0",
      "78": "43.0",
      "80": "45.0",
      "85": "48.0",
      "90": "51.0",
      "95": "53.0",
      "100": "55.0"
    }
  },
  "大学一二年级_女_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "大学一二年级",
    "gender": "女",
    "display_order": 6,
    "scoring_table": {
      "10": "16",
      "20": "18",
      "30": "20",
      "40": "22",
      "50": "24",
      "60": "26",
      "62": "28",
      "64": "30",
      "66": "32",
      "68": "34",
      "70": "36",
      "72": "38",
      "74": "40",
      "76": "42",
      "78": "44",
      "80": "46",
      "85": "49",
      "90": "52",
      "95": "54",
      "100": "56"
    }
  },
  "大学三四年级_女_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "大学三四年级",
    "gender": "女",
    "display_order": 6,
    "scoring_table": {
      "10": "17",
      "20": "19",
      "30": "21",
      "40": "23",
      "50": "25",
      "60": "27",
      "62": "29",
      "64": "31",
      "66": "33",
      "68": "35",
      "70": "37",
      "72": "39",
      "74": "41",
      "76": "43",
      "78": "45",
      "80": "47",
      "85": "50",
      "90": "53",
      "95": "55",
      "100": "57"
    }
  },
  "初中一年级_男_run_1000m": {
    "item_code": "run_1000m",
    "item_name": "1000米跑",
    "grade": "初中一年级",
    "gender": "男",
    "display_order": 7,
    "scoring_table": {
      "10": "7'00\"",
      "20": "6'40\"",
      "30": "6'20\"",
      "40": "6'00\"",
      "50": "5'40\"",
      "60": "5'20\"",
      "62": "5'15\"",
      "64": "5'10\"",
      "66": "5'05\"",
      "68": "5'00\"",
      "70": "4'55\"",
      "72": "4'50\"",
      "74": "4'45\"",
      "76": "4'40\"",
      "78": "4'35\"",
      "80": "4'30\"",
      "85": "4'22\"",
      "90": "4'15\"",
      "95": "4'05\"",
      "100": "3'55\""
    }
  },
  "初中二年级_男_run_1000m": {
    "item_code": "run_1000m",
    "item_name": "1000米跑",
    "grade": "初中二年级",
    "gender": "男",
    "display_order": 7,
    "scoring_table": {
      "10": "6'45\"",
      "20": "6'25\"",
      "30": "6'05\"",
      "40": "5'45\"",
      "50": "5'25\"",
      "60": "5'05\"",
      "62": "5'00\"",
      "64": "4'55\"",
      "66": "4'50\"",
      "68": "4'45\"",
      "70": "4'40\"",
      "72": "4'35\"",
      "74": "4'30\"",
      "76": "4'25\"",
      "78": "4'20\"",
      "80": "4'15\"",
      "85": "4'07\"",
      "90": "4'00\"",
      "95": "3'55\"",
      "100": "3'50\""
    }
  },
  "初中三年级_男_run_1000m": {
    "item_code": "run_1000m",
    "item_name": "1000米跑",
    "grade": "初中三年级",
    "gender": "男",
    "display_order": 7,
    "scoring_table": {
      "10": "6'35\"",
      "20": "6'15\"",
      "30": "5'55\"",
      "40": "5'35\"",
      "50": "5'15\"",
      "60": "4'55\"",
      "62": "4'50\"",
      "64": "4'45\"",
      "66": "4'40\"",
      "68": "4'35\"",
      "70": "4'30\"",
      "72": "4'25\"",
      "74": "4'20\"",
      "76": "4'15\"",
      "78": "4'10\"",
      "80": "4'05\"",
      "85": "3'57\"",
      "90": "3'50\"",
      "95": "3'45\"",
      "100": "3'40\""
    }
  },
  "高中一年级_男_run_1000m": {
    "item_code": "run_1000m",
    "item_name": "1000米跑",
    "grade": "高中一年级",
    "gender": "男",
    "display_order": 7,
    "scoring_table": {
      "10": "6'25\"",
      "20": "6'05\"",
      "30": "5'45\"",
      "40": "5'25\"",
      "50": "5'05\"",
      "60": "4'45\"",
      "62": "4'40\"",
      "64": "4'35\"",
      "66": "4'30\"",
      "68": "4'25\"",
      "70": "4'20\"",
      "72": "4'15\"",
      "74": "4'10\"",
      "76": "4'05\"",
      "78": "4'00\"",
      "80": "3'55\"",
      "85": "3'47\"",
      "90": "3'40\"",
      "95": "3'35\"",
      "100": "3'30\""
    }
  },
  "高中二年级_男_run_1000m": {
    "item_code": "run_1000m",
    "item_name": "1000米跑",
    "grade": "高中二年级",
    "gender": "男",
    "display_order": 7,
    "scoring_table": {
      "10": "6'20\"",
      "20": "6'00\"",
      "30": "5'40\"",
      "40": "5'20\"",
      "50": "5'00\"",
      "60": "4'40\"",
      "62": "4'35\"",
      "64": "4'30\"",
      "66": "4'25\"",
      "68": "4'20\"",
      "70": "4'15\"",
      "72": "4'10\"",
      "74": "4'05\"",
      "76": "4'00\"",
      "78": "3'55\"",
      "80": "3'50\"",
      "85": "3'42\"",
      "90": "3'35\"",
      "95": "3'30\"",
      "100": "3'25\""
    }
  },
  "高中三年级_男_run_1000m": {
    "item_code": "run_1000m",
    "item_name": "1000米跑",
    "grade": "高中三年级",
    "gender": "男",
    "display_order": 7,
    "scoring_table": {
      "10": "6'15\"",
      "20": "5'55\"",
      "30": "5'35\"",
      "40": "5'15\"",
      "50": "4'55\"",
      "60": "4'35\"",
      "62": "4'30\"",
      "64": "4'25\"",
      "66": "4'20\"",
      "68": "4'15\"",
      "70": "4'10\"",
      "72": "4'05\"",
      "74": "4'00\"",
      "76": "3'55\"",
      "78": "3'50\"",
      "80": "3'45\"",
      "85": "3'37\"",
      "90": "3'30\"",
      "95": "3'25\"",
      "100": "3'20\""
    }
  },
  "大学一二年级_男_run_1000m": {
    "item_code": "run_1000m",
    "item_name": "1000米跑",
    "grade": "大学一二年级",
    "gender": "男",
    "display_order": 7,
    "scoring_table": {
      "10": "6'12\"",
      "20": "5'52\"",
      "30": "5'32\"",
      "40": "5'12\"",
      "50": "4'52\"",
      "60": "4'32\"",
      "62": "4'27\"",
      "64": "4'22\"",
      "66": "4'17\"",
      "68": "4'12\"",
      "70": "4'07\"",
      "72": "4'02\"",
      "74": "3'57\"",
      "76": "3'52\"",
      "78": "3'47\"",
      "80": "3'42\"",
      "85": "3'34\"",
      "90": "3'27\"",
      "95": "3'22\"",
      "100": "3'17\""
    }
  },
  "大学三四年级_男_run_1000m": {
    "item_code": "run_1000m",
    "item_name": "1000米跑",
    "grade": "大学三四年级",
    "gender": "男",
    "display_order": 7,
    "scoring_table": {
      "10": "6'10\"",
      "20": "5'50\"",
      "30": "5'30\"",
      "40": "5'10\"",
      "50": "4'50\"",
      "60": "4'30\"",
      "62": "4'25\"",
      "64": "4'20\"",
      "66": "4'15\"",
      "68": "4'10\"",
      "70": "4'05\"",
      "72": "4'00\"",
      "74": "3'55\"",
      "76": "3'50\"",
      "78": "3'45\"",
      "80": "3'40\"",
      "85": "3'32\"",
      "90": "3'25\"",
      "95": "3'20\"",
      "100": "3'15\""
    }
  },
  "初中一年级_女_run_800m": {
    "item_code": "run_800m",
    "item_name": "800米跑",
    "grade": "初中一年级",
    "gender": "女",
    "display_order": 7,
    "scoring_table": {
      "10": "5'45\"",
      "20": "5'35\"",
      "30": "5'25\"",
      "40": "5'15\"",
      "50": "5'05\"",
      "60": "4'55\"",
      "62": "4'50\"",
      "64": "4'45\"",
      "66": "4'40\"",
      "68": "4'35\"",
      "70": "4'30\"",
      "72": "4'25\"",
      "74": "4'20\"",
      "76": "4'15\"",
      "78": "4'10\"",
      "80": "4'05\"",
      "85": "3'57\"",
      "90": "3'49\"",
      "95": "3'42\"",
      "100": "3'35\""
    }
  },
  "初中二年级_女_run_800m": {
    "item_code": "run_800m",
    "item_name": "800米跑",
    "grade": "初中二年级",
    "gender": "女",
    "display_order": 7,
    "scoring_table": {
      "10": "5'40\"",
      "20": "5'30\"",
      "30": "5'20\"",
      "40": "5'10\"",
      "50": "5'00\"",
      "60": "4'50\"",
      "62": "4'45\"",
      "64": "4'40\"",
      "66": "4'35\"",
      "68": "4'30\"",
      "70": "4'25\"",
      "72": "4'20\"",
      "74": "4'15\"",
      "76": "4'10\"",
      "78": "4'05\"",
      "80": "4'00\"",
      "85": "3'52\"",
      "90": "3'44\"",
      "95": "3'37\"",
      "100": "3'30\""
    }
  },
  "初中三年级_女_run_800m": {
    "item_code": "run_800m",
    "item_name": "800米跑",
    "grade": "初中三年级",
    "gender": "女",
    "display_order": 7,
    "scoring_table": {
      "10": "5'35\"",
      "20": "5'25\"",
      "30": "5'15\"",
      "40": "5'05\"",
      "50": "4'55\"",
      "60": "4'45\"",
      "62": "4'40\"",
      "64": "4'35\"",
      "66": "4'30\"",
      "68": "4'25\"",
      "70": "4'20\"",
      "72": "4'15\"",
      "74": "4'10\"",
      "76": "4'05\"",
      "78": "4'00\"",
      "80": "3'55\"",
      "85": "3'47\"",
      "90": "3'39\"",
      "95": "3'32\"",
      "100": "3'25\""
    }
  },
  "高中一年级_女_run_800m": {
    "item_code": "run_800m",
    "item_name": "800米跑",
    "grade": "高中一年级",
    "gender": "女",
    "display_order": 7,
    "scoring_table": {
      "10": "5'30\"",
      "20": "5'20\"",
      "30": "5'10\"",
      "40": "5'00\"",
      "50": "4'50\"",
      "60": "4'40\"",
      "62": "4'35\"",
      "64": "4'30\"",
      "66": "4'25\"",
      "68": "4'20\"",
      "70": "4'15\"",
      "72": "4'10\"",
      "74": "4'05\"",
      "76": "4'00\"",
      "78": "3'55\"",
      "80": "3'50\"",
      "85": "3'43\"",
      "90": "3'36\"",
      "95": "3'30\"",
      "100": "3'24\""
    }
  },
  "高中二年级_女_run_800m": {
    "item_code": "run_800m",
    "item_name": "800米跑",
    "grade": "高中二年级",
    "gender": "女",
    "display_order": 7,
    "scoring_table": {
      "10": "5'28\"",
      "20": "5'18\"",
      "30": "5'08\"",
      "40": "4'58\"",
      "50": "4'48\"",
      "60": "4'38\"",
      "62": "4'33\"",
      "64": "4'28\"",
      "66": "4'23\"",
      "68": "4'18\"",
      "70": "4'13\"",
      "72": "4'08\"",
      "74": "4'03\"",
      "76": "3'58\"",
      "78": "3'53\"",
      "80": "3'48\"",
      "85": "3'41\"",
      "90": "3'34\"",
      "95": "3'28\"",
      "100": "3'22\""
    }
  },
  "高中三年级_女_run_800m": {
    "item_code": "run_800m",
    "item_name": "800米跑",
    "grade": "高中三年级",
    "gender": "女",
    "display_order": 7,
    "scoring_table": {
      "10": "5'26\"",
      "20": "5'16\"",
      "30": "5'06\"",
      "40": "4'56\"",
      "50": "4'46\"",
      "60": "4'36\"",
      "62": "4'31\"",
      "64": "4'26\"",
      "66": "4'21\"",
      "68": "4'16\"",
      "70": "4'11\"",
      "72": "4'06\"",
      "74": "4'01\"",
      "76": "3'56\"",
      "78": "3'51\"",
      "80": "3'46\"",
      "85": "3'39\"",
      "90": "3'32\"",
      "95": "3'26\"",
      "100": "3'20\""
    }
  },
  "大学一二年级_女_run_800m": {
    "item_code": "run_800m",
    "item_name": "800米跑",
    "grade": "大学一二年级",
    "gender": "女",
    "display_order": 7,
    "scoring_table": {
      "10": "5'24\"",
      "20": "5'14\"",
      "30": "5'04\"",
      "40": "4'54\"",
      "50": "4'44\"",
      "60": "4'34\"",
      "62": "4'29\"",
      "64": "4'24\"",
      "66": "4'19\"",
      "68": "4'14\"",
      "70": "4'09\"",
      "72": "4'04\"",
      "74": "3'59\"",
      "76": "3'54\"",
      "78": "3'49\"",
      "80": "3'44\"",
      "85": "3'37\"",
      "90": "3'30\"",
      "95": "3'24\"",
      "100": "3'18\""
    }
  },
  "大学三四年级_女_run_800m": {
    "item_code": "run_800m",
    "item_name": "800米跑",
    "grade": "大学三四年级",
    "gender": "女",
    "display_order": 7,
    "scoring_table": {
      "10": "5'22\"",
      "20": "5'12\"",
      "30": "5'02\"",
      "40": "4'52\"",
      "50": "4'42\"",
      "60": "4'32\"",
      "62": "4'27\"",
      "64": "4'22\"",
      "66": "4'17\"",
      "68": "4'12\"",
      "70": "4'07\"",
      "72": "4'02\"",
      "74": "3'57\"",
      "76": "3'52\"",
      "78": "3'47\"",
      "80": "3'42\"",
      "85": "3'35\"",
      "90": "3'28\"",
      "95": "3'22\"",
      "100": "3'16\""
    }
  },
  "小学三年级_男_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "小学三年级",
    "gender": "男",
    "display_order": 6,
    "scoring_table": {
      "10": "6",
      "20": "8",
      "30": "10",
      "40": "12",
      "50": "14",
      "60": "16",
      "62": "18",
      "64": "20",
      "66": "22",
      "68": "24",
      "70": "26",
      "72": "28",
      "74": "30",
      "76": "32",
      "78": "34",
      "80": "36",
      "85": "39",
      "90": "42",
      "95": "45",
      "100": "48"
    }
  },
  "小学四年级_男_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "小学四年级",
    "gender": "男",
    "display_order": 6,
    "scoring_table": {
      "10": "7",
      "20": "9",
      "30": "11",
      "40": "13",
      "50": "15",
      "60": "17",
      "62": "19",
      "64": "21",
      "66": "23",
      "68": "25",
      "70": "27",
      "72": "29",
      "74": "31",
      "76": "33",
      "78": "35",
      "80": "37",
      "85": "40",
      "90": "43",
      "95": "46",
      "100": "49"
    }
  },
  "小学五年级_男_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "小学五年级",
    "gender": "男",
    "display_order": 6,
    "scoring_table": {
      "10": "8",
      "20": "10",
      "30": "12",
      "40": "14",
      "50": "16",
      "60": "18",
      "62": "20",
      "64": "22",
      "66": "24",
      "68": "26",
      "70": "28",
      "72": "30",
      "74": "32",
      "76": "34",
      "78": "36",
      "80": "38",
      "85": "41",
      "90": "44",
      "95": "47",
      "100": "50"
    }
  },
  "小学六年级_男_sit_up": {
    "item_code": "sit_up",
    "item_name": "一分钟仰卧起坐",
    "grade": "小学六年级",
    "gender": "男",
    "display_order": 6,
    "scoring_table": {
      "10": "9",
      "20": "11",
      "30": "13",
      "40": "15",
      "50": "17",
      "60": "19",
      "62": "21",
      "64": "23",
      "66": "25",
      "68": "27",
      "70": "29",
      "72": "31",
      "74": "33",
      "76": "35",
      "78": "37",
      "80": "39",
      "85": "42",
      "90": "45",
      "95": "48",
      "100": "51"
    }
  },
  "小学五年级_男_run_50m8x": {
    "item_code": "run_50m8x",
    "item_name": "50米×8往返跑",
    "grade": "小学五年级",
    "gender": "男",
    "display_order": 7,
    "scoring_table": {
      "10": "2'38\"",
      "20": "2'34\"",
      "30": "2'30\"",
      "40": "2'26\"",
      "50": "2'22\"",
      "60": "2'18\"",
      "62": "2'15\"",
      "64": "2'12\"",
      "66": "2'09\"",
      "68": "2'06\"",
      "70": "2'03\"",
      "72": "2'00\"",
      "74": "1'57\"",
      "76": "1'54\"",
      "78": "1'51\"",
      "80": "1'48\"",
      "85": "1'45\"",
      "90": "1'42\"",
      "95": "1'39\"",
      "100": "1'36\""
    }
  },
  "小学五年级_女_run_50m8x": {
    "item_code": "run_50m8x",
    "item_name": "50米×8往返跑",
    "grade": "小学五年级",
    "gender": "女",
    "display_order": 7,
    "scoring_table": {
      "10": "2'43\"",
      "20": "2'39\"",
      "30": "2'35\"",
      "40": "2'31\"",
      "50": "2'27\"",
      "60": "2'23\"",
      "62": "2'20\"",
      "64": "2'17\"",
      "66": "2'14\"",
      "68": "2'11\"",
      "70": "2'08\"",
      "72": "2'05\"",
      "74": "2'02\"",
      "76": "1'59\"",
      "78": "1'56\"",
      "80": "1'53\"",
      "85": "1'50\"",
      "90": "1'47\"",
      "95": "1'44\"",
      "100": "1'41\""
    }
  },
  "小学六年级_男_run_50m8x": {
    "item_code": "run_50m8x",
    "item_name": "50米×8往返跑",
    "grade": "小学六年级",
    "gender": "男",
    "display_order": 7,
    "scoring_table": {
      "10": "2'32\"",
      "20": "2'28\"",
      "30": "2'24\"",
      "40": "2'20\"",
      "50": "2'16\"",
      "60": "2'12\"",
      "62": "2'09\"",
      "64": "2'06\"",
      "66": "2'03\"",
      "68": "2'00\"",
      "70": "1'57\"",
      "72": "1'54\"",
      "74": "1'51\"",
      "76": "1'48\"",
      "78": "1'45\"",
      "80": "1'42\"",
      "85": "1'39\"",
      "90": "1'36\"",
      "95": "1'33\"",
      "100": "1'30\""
    }
  },
  "小学六年级_女_run_50m8x": {
    "item_code": "run_50m8x",
    "item_name": "50米×8往返跑",
    "grade": "小学六年级",
    "gender": "女",
    "display_order": 7,
    "scoring_table": {
      "10": "2'39\"",
      "20": "2'35\"",
      "30": "2'31\"",
      "40": "2'27\"",
      "50": "2'23\"",
      "60": "2'19\"",
      "62": "2'16\"",
      "64": "2'13\"",
      "66": "2'10\"",
      "68": "2'07\"",
      "70": "2'04\"",
      "72": "2'01\"",
      "74": "1'58\"",
      "76": "1'55\"",
      "78": "1'52\"",
      "80": "1'49\"",
      "85": "1'46\"",
      "90": "1'43\"",
      "95": "1'40\"",
      "100": "1'37\""
    }
  },
  "大学一二年级_男_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "大学一二年级",
    "gender": "男",
    "display_order": 1,
    "scoring_table": {
      "60": "≥28.0",
      "80": "≤17.8",
      "100": "17.9~23.9"
    }
  },
  "大学一二年级_女_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "大学一二年级",
    "gender": "女",
    "display_order": 1,
    "scoring_table": {
      "60": "≥28.0",
      "80": "≤17.1;24.0~27.9",
      "100": "17.2~23.9"
    }
  },
  "大学三四年级_男_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "大学三四年级",
    "gender": "男",
    "display_order": 1,
    "scoring_table": {
      "60": "≥28.0",
      "80": "≤17.8",
      "100": "17.9~23.9"
    }
  },
  "大学三四年级_女_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "大学三四年级",
    "gender": "女",
    "display_order": 1,
    "scoring_table": {
      "60": "≥28.0",
      "80": "≤17.1;24.0~27.9",
      "100": "17.2~23.9"
    }
  },
  "小学一年级_女_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "小学一年级",
    "gender": "女",
    "display_order": 1,
    "scoring_table": {
      "60": "≥19.3",
      "80": "≤13.2;17.4~19.2",
      "100": "13.3~17.3"
    }
  },
  "小学二年级_女_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "小学二年级",
    "gender": "女",
    "display_order": 1,
    "scoring_table": {
      "60": "≥20.3",
      "80": "≤13.4;17.9~20.2",
      "100": "13.5~17.8"
    }
  },
  "小学三年级_女_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "小学三年级",
    "gender": "女",
    "display_order": 1,
    "scoring_table": {
      "60": "≥21.2",
      "80": "≤13.5;18.7~21.1",
      "100": "13.6~18.6"
    }
  },
  "小学四年级_女_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "小学四年级",
    "gender": "女",
    "display_order": 1,
    "scoring_table": {
      "60": "≥22.1",
      "80": "≤13.6;19.5~22.0",
      "100": "13.7~19.4"
    }
  },
  "小学五年级_女_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "小学五年级",
    "gender": "女",
    "display_order": 1,
    "scoring_table": {
      "60": "≥23.0",
      "80": "≤13.7;20.6~22.9",
      "100": "13.8~20.5"
    }
  },
  "小学六年级_女_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "小学六年级",
    "gender": "女",
    "display_order": 1,
    "scoring_table": {
      "60": "≥23.7",
      "80": "≤14.1;20.9~23.6",
      "100": "14.2~20.8"
    }
  },
  "初中一年级_女_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "初中一年级",
    "gender": "女",
    "display_order": 1,
    "scoring_table": {
      "60": "≥24.5",
      "80": "≤14.7;21.8~24.4",
      "100": "14.8~21.7"
    }
  },
  "初中二年级_女_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "初中二年级",
    "gender": "女",
    "display_order": 1,
    "scoring_table": {
      "60": "≥24.9",
      "80": "≤15.2;22.3~24.8",
      "100": "15.3~22.2"
    }
  },
  "初中三年级_女_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "初中三年级",
    "gender": "女",
    "display_order": 1,
    "scoring_table": {
      "60": "≥25.2",
      "80": "≤15.9;22.7~25.1",
      "100": "16.0~22.6"
    }
  },
  "高中一年级_女_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "高中一年级",
    "gender": "女",
    "display_order": 1,
    "scoring_table": {
      "60": "≥25.3",
      "80": "≤16.4;22.8~25.2",
      "100": "16.5~22.7"
    }
  },
  "高中二年级_女_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "高中二年级",
    "gender": "女",
    "display_order": 1,
    "scoring_table": {
      "60": "≥25.5",
      "80": "≤16.8;23.3~25.4",
      "100": "16.9~23.2"
    }
  },
  "高中三年级_女_bmi": {
    "item_code": "bmi",
    "item_name": "体重指数(BMI)",
    "grade": "高中三年级",
    "gender": "女",
    "display_order": 1,
    "scoring_table": {
      "60": "≥25.8",
      "80": "≤17.0;23.4~25.7",
      "100": "17.1~23.3"
    }
  }
};
